"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.TRANSLATIONS = exports.CURRENT_LANG = exports.T = void 0;
exports.load = load;
exports.Translate = Translate;
var T;
(function (T) {
    T["EMPTY"] = "EMPTY";
    T["IKE_OFFICE"] = "IKE_OFFICE";
    T["IKE_OFFICE_PRO"] = "IKE_OFFICE_PRO";
    T["ACCOUNT_LOCKED"] = "ACCOUNT_LOCKED";
    T["ACCOUNTS_TITLE"] = "ACCOUNTS_TITLE";
    T["ACCOUNTS_USERNAME"] = "ACCOUNTS_USERNAME";
    T["ACCOUNTS_NAME"] = "ACCOUNTS_NAME";
    T["ACCOUNTS_ROLE"] = "ACCOUNTS_ROLE";
    T["ACCOUNTS_INVITES_PENDING"] = "ACCOUNTS_INVITES_PENDING";
    T["ACCOUNTS_NO_INVITES_PENDING"] = "ACCOUNTS_NO_INVITES_PENDING";
    T["ACCOUNTS_INVITE_EXPIRES"] = "ACCOUNTS_INVITE_EXPIRES";
    T["ACCOUNTS_INVITE"] = "ACCOUNTS_INVITE";
    T["ACCOUNTS_INVITE_TITLE"] = "ACCOUNTS_INVITE_TITLE";
    T["ACCOUNTS_INVITE_CONFIRM"] = "ACCOUNTS_INVITE_CONFIRM";
    T["ACCOUNTS_INVITE_SUCCESS"] = "ACCOUNTS_INVITE_SUCCESS";
    T["ACCOUNTS_ADDED_USER"] = "ACCOUNTS_ADDED_USER";
    T["ACCOUNTS_INVITE_EXISTING_USER"] = "ACCOUNTS_INVITE_EXISTING_USER";
    T["ACCOUNTS_INVITE_INVALID_USER"] = "ACCOUNTS_INVITE_INVALID_USER";
    T["ACCOUNTS_INVITE_MAX"] = "ACCOUNTS_INVITE_MAX";
    T["ACCOUNTS_INVITE_CHOOSE_USER_ROLE"] = "ACCOUNTS_INVITE_CHOOSE_USER_ROLE";
    T["ACCOUNTS_REMOVE"] = "ACCOUNTS_REMOVE";
    T["ACCOUNTS_REMOVE_TITLE"] = "ACCOUNTS_REMOVE_TITLE";
    T["ACCOUNTS_REMOVE_CONFIRM"] = "ACCOUNTS_REMOVE_CONFIRM";
    T["ACCOUNTS_REMOVE_SUCCESS"] = "ACCOUNTS_REMOVE_SUCCESS";
    T["ACCOUNTS_REVOKE"] = "ACCOUNTS_REVOKE";
    T["ACCOUNTS_REVOKE_TITLE"] = "ACCOUNTS_REVOKE_TITLE";
    T["ACCOUNTS_REVOKE_CONFIRM"] = "ACCOUNTS_REVOKE_CONFIRM";
    T["ACCOUNTS_REVOKE_SUCCESS"] = "ACCOUNTS_REVOKE_SUCCESS";
    T["ACCOUNTS_DEMOTE"] = "ACCOUNTS_DEMOTE";
    T["ACCOUNTS_DEMOTE_TITLE"] = "ACCOUNTS_DEMOTE_TITLE";
    T["ACCOUNTS_DEMOTE_CONFIRM"] = "ACCOUNTS_DEMOTE_CONFIRM";
    T["ACCOUNTS_DEMOTE_SUCCESS"] = "ACCOUNTS_DEMOTE_SUCCESS";
    T["ACCOUNTS_PROMOTE"] = "ACCOUNTS_PROMOTE";
    T["ACCOUNTS_PROMOTE_TITLE"] = "ACCOUNTS_PROMOTE_TITLE";
    T["ACCOUNTS_PROMOTE_CONFIRM"] = "ACCOUNTS_PROMOTE_CONFIRM";
    T["ACCOUNTS_PROMOTE_SUCCESS"] = "ACCOUNTS_PROMOTE_SUCCESS";
    T["ACCOUNTS_SET_ROLE"] = "ACCOUNTS_SET_ROLE";
    T["ACCOUNTS_SET_ROLE_TITLE"] = "ACCOUNTS_SET_ROLE_TITLE";
    T["ACCOUNTS_SET_ROLE_CONFIRM"] = "ACCOUNTS_SET_ROLE_CONFIRM";
    T["ACCOUNTS_SET_ROLE_SUCCESS"] = "ACCOUNTS_SET_ROLE_SUCCESS";
    T["AUTH0_WARNING"] = "AUTH0_WARNING";
    T["BANNER_MESSAGE_PT1"] = "BANNER_MESSAGE_PT1";
    T["BANNER_MESSAGE_PT2"] = "BANNER_MESSAGE_PT2";
    T["OK"] = "OK";
    T["CANCEL"] = "CANCEL";
    T["NEXT"] = "NEXT";
    T["CLOSE"] = "CLOSE";
    T["CONTINUE"] = "CONTINUE";
    T["HERE"] = "HERE";
    T["SEND"] = "SEND";
    T["TRY_AGAIN"] = "TRY_AGAIN";
    T["ACCEPT"] = "ACCEPT";
    T["COLOR"] = "COLOR";
    T["ALTITUDE_MISSING"] = "ALTITUDE_MISSING";
    T["LATITUDE_MISSING"] = "LATITUDE_MISSING";
    T["LONGITUDE_MISSING"] = "LONGITUDE_MISSING";
    T["LOCATION_FIELD_OUT_OF_RANGE"] = "LOCATION_FIELD_OUT_OF_RANGE";
    T["BEARING_INVALID"] = "BEARING_INVALID";
    T["BEARING_MISSING"] = "BEARING_MISSING";
    T["PLACEMENT_MISSING"] = "PLACEMENT_MISSING";
    T["ACCURATE_ANCHOR_RELATED_SPAN_NO_VALUE"] = "ACCURATE_ANCHOR_RELATED_SPAN_NO_VALUE";
    T["ACCURATE_ANCHOR_RELATED_SPAN_NO_SELECTION_BISECT"] = "ACCURATE_ANCHOR_RELATED_SPAN_NO_SELECTION_BISECT";
    T["ACCURATE_ANCHOR_RELATED_SPAN_NO_SELECTION_INLINE"] = "ACCURATE_ANCHOR_RELATED_SPAN_NO_SELECTION_INLINE";
    T["ACCURATE_ANCHOR_RELATED_SPAN_TITLE"] = "ACCURATE_ANCHOR_RELATED_SPAN_TITLE";
    T["DATE_INVALID"] = "DATE_INVALID";
    T["DEPARTMENT"] = "DEPARTMENT";
    T["DRAWABLE_BASE_OFFSET"] = "DRAWABLE_BASE_OFFSET";
    T["DRAWABLE_TITLE"] = "DRAWABLE_TITLE";
    T["STATUS"] = "STATUS";
    T["DASHBOARD_POLE_STATUS"] = "DASHBOARD_POLE_STATUS";
    T["DASHBOARD_POLE_LOADING"] = "DASHBOARD_POLE_LOADING";
    T["DASHBOARD"] = "DASHBOARD";
    T["EMAIL_INVALID"] = "EMAIL_INVALID";
    T["EMAIL_EXISTS_IN_DEPARTMENT"] = "EMAIL_EXISTS_IN_DEPARTMENT";
    T["ENTER_VALID_EMAIL"] = "ENTER_VALID_EMAIL";
    T["USER_ALREADY_EXISTS"] = "USER_ALREADY_EXISTS";
    T["USER_ALREADY_EXISTS_DESCRIPTION"] = "USER_ALREADY_EXISTS_DESCRIPTION";
    T["ERROR_GENERAL"] = "ERROR_GENERAL";
    T["ERROR_INFECTED"] = "ERROR_INFECTED";
    T["ERROR_DOWNLOAD_FAIL"] = "ERROR_DOWNLOAD_FAIL";
    T["ERROR_EXPORT"] = "ERROR_EXPORT";
    T["LOADING"] = "LOADING";
    T["LOAD_MORE"] = "LOAD_MORE";
    T["SEARCH"] = "SEARCH";
    T["SEARCH_RES"] = "SEARCH_RES";
    T["CLEAR_SEARCH"] = "CLEAR_SEARCH";
    T["SEARCH_ERROR"] = "SEARCH_ERROR";
    T["LAST_UPDATED_AT"] = "LAST_UPDATED_AT";
    T["TAG_TITLE"] = "TAG_TITLE";
    T["TAG_NAME"] = "TAG_NAME";
    T["TAG_TITLE_SELECTION"] = "TAG_TITLE_SELECTION";
    T["TAG_FILTER"] = "TAG_FILTER";
    T["TAG_FILTER__SEARCH_EMPTY"] = "TAG_FILTER__SEARCH_EMPTY";
    T["TAG_ZOOM"] = "TAG_ZOOM";
    T["TAG_EXISTS"] = "TAG_EXISTS";
    T["TAG_MERGE_TITLE"] = "TAG_MERGE_TITLE";
    T["TAG_MERGE_CONFIRM"] = "TAG_MERGE_CONFIRM";
    T["TAG_PHOTO"] = "TAG_PHOTO";
    T["CLOSE_WINDOW"] = "CLOSE_WINDOW";
    T["COLLECTION_TITLE"] = "COLLECTION_TITLE";
    T["COLLECTION_MISSING"] = "COLLECTION_MISSING";
    T["COLLECTION_MISSING_TITLE"] = "COLLECTION_MISSING_TITLE";
    T["COLLECTION_COLLECTED_AT"] = "COLLECTION_COLLECTED_AT";
    T["COLLECTION_COLLECTED_BY"] = "COLLECTION_COLLECTED_BY";
    T["COLLECTION_UPDATED_AT"] = "COLLECTION_UPDATED_AT";
    T["COLLECTION_UPDATED_BY"] = "COLLECTION_UPDATED_BY";
    T["COLLECTION_ASSIGNED_TO"] = "COLLECTION_ASSIGNED_TO";
    T["COLLECTION_FORM_NAME"] = "COLLECTION_FORM_NAME";
    T["COLLECTION_FORM_VERSION"] = "COLLECTION_FORM_VERSION";
    T["COLLECTION_SHOW_META"] = "COLLECTION_SHOW_META";
    T["COLLECTION_SHOW_ZOOM"] = "COLLECTION_SHOW_ZOOM";
    T["COLLECTION_EXPAND_ALL"] = "COLLECTION_EXPAND_ALL";
    T["COLLECTION_COLLAPSE_ALL"] = "COLLECTION_COLLAPSE_ALL";
    T["COLLECTION_ASSIGN"] = "COLLECTION_ASSIGN";
    T["COLLECTION_UNASSIGNED"] = "COLLECTION_UNASSIGNED";
    T["COLLECTION_ASSIGN_TITLE"] = "COLLECTION_ASSIGN_TITLE";
    T["COLLECTION_ASSIGN_CONFIRM"] = "COLLECTION_ASSIGN_CONFIRM";
    T["COLLECTION_ASSIGN_SUCCESS"] = "COLLECTION_ASSIGN_SUCCESS";
    T["COLLECTION_MOVE"] = "COLLECTION_MOVE";
    T["COLLECTION_MOVE_TITLE"] = "COLLECTION_MOVE_TITLE";
    T["COLLECTION_MOVE_CONFIRM"] = "COLLECTION_MOVE_CONFIRM";
    T["COLLECTION_MOVE_SUCCESS"] = "COLLECTION_MOVE_SUCCESS";
    T["COLLECTION_MOVE_JOB"] = "COLLECTION_MOVE_JOB";
    T["COLLECTION_MOVE_JOB_TITLE"] = "COLLECTION_MOVE_JOB_TITLE";
    T["COLLECTION_MOVE_JOB_INPUT_ERROR"] = "COLLECTION_MOVE_JOB_INPUT_ERROR";
    T["COLLECTION_MOVE_DEPARTMENT"] = "COLLECTION_MOVE_DEPARTMENT";
    T["COLLECTION_STATUS"] = "COLLECTION_STATUS";
    T["CLEAR_COLLECTION_STATUS"] = "CLEAR_COLLECTION_STATUS";
    T["COLLECTION_STATUS_TITLE"] = "COLLECTION_STATUS_TITLE";
    T["COLLECTION_STATUS_CONFIRM"] = "COLLECTION_STATUS_CONFIRM";
    T["COLLECTION_STATUS_SUCCESS"] = "COLLECTION_STATUS_SUCCESS";
    T["COLLECTION_STATUS_CANNOT_CHANGE"] = "COLLECTION_STATUS_CANNOT_CHANGE";
    T["COLLECTION_MIGRATE_FORM"] = "COLLECTION_MIGRATE_FORM";
    T["COLLECTION_MIGRATE_FORM_TITLE"] = "COLLECTION_MIGRATE_FORM_TITLE";
    T["COLLECTION_MIGRATE_FORM_SUCCESS"] = "COLLECTION_MIGRATE_FORM_SUCCESS";
    T["COLLECTION_MIGRATE_FORM_FAIL"] = "COLLECTION_MIGRATE_FORM_FAIL";
    T["COLLECTION_MIGRATE_FORM_BODY_WARNING_TITLE"] = "COLLECTION_MIGRATE_FORM_BODY_WARNING_TITLE";
    T["COLLECTION_MIGRATE_FORM_BODY_WARNING_DESCRIPTION_PT1"] = "COLLECTION_MIGRATE_FORM_BODY_WARNING_DESCRIPTION_PT1";
    T["COLLECTION_MIGRATE_FORM_BODY_WARNING_DESCRIPTION_PT2"] = "COLLECTION_MIGRATE_FORM_BODY_WARNING_DESCRIPTION_PT2";
    T["COLLECTION_MIGRATE_FORM_BODY_WARNING_DESCRIPTION_PT3"] = "COLLECTION_MIGRATE_FORM_BODY_WARNING_DESCRIPTION_PT3";
    T["COLLECTION_MIGRATE_FORM_BODY_WARNING_DESCRIPTION_PT4"] = "COLLECTION_MIGRATE_FORM_BODY_WARNING_DESCRIPTION_PT4";
    T["COLLECTION_MIGRATE_FORM_BODY"] = "COLLECTION_MIGRATE_FORM_BODY";
    T["COLLECTION_MIGRATE_FORM_BODY_NO_FORMS"] = "COLLECTION_MIGRATE_FORM_BODY_NO_FORMS";
    T["COLLECTION_UPDATE_FORM"] = "COLLECTION_UPDATE_FORM";
    T["COLLECTION_UPDATE_FORM_TITLE"] = "COLLECTION_UPDATE_FORM_TITLE";
    T["COLLECTION_UPDATE_FORM_CONFIRM"] = "COLLECTION_UPDATE_FORM_CONFIRM";
    T["COLLECTION_UPDATE_FORM_SUCCESS"] = "COLLECTION_UPDATE_FORM_SUCCESS";
    T["COLLECTION_UPDATE_FORM_CURRENT_REVISION"] = "COLLECTION_UPDATE_FORM_CURRENT_REVISION";
    T["COLLECTION_UPDATE_FORM_LATEST_REVISION"] = "COLLECTION_UPDATE_FORM_LATEST_REVISION";
    T["COLLECTION_UPDATE_FORM_ERROR"] = "COLLECTION_UPDATE_FORM_ERROR";
    T["COLLECTION_UPDATE_HAS_LATEST_FORM"] = "COLLECTION_UPDATE_HAS_LATEST_FORM";
    T["COLLECTION_UPDATE_FORM_ERROR_TITLE"] = "COLLECTION_UPDATE_FORM_ERROR_TITLE";
    T["COLLECTION_UPDATE_FORM_FIELD_MISSING"] = "COLLECTION_UPDATE_FORM_FIELD_MISSING";
    T["COLLECTION_UPDATE_FORM_FIELD_VALUE_MISSING"] = "COLLECTION_UPDATE_FORM_FIELD_VALUE_MISSING";
    T["COLLECTION_UPDATE_FORM_REASON"] = "COLLECTION_UPDATE_FORM_REASON";
    T["COLLECTION_UPDATE_FORM_FIELD_NAME"] = "COLLECTION_UPDATE_FORM_FIELD_NAME";
    T["COLLECTION_UPDATE_FORM_VALUE"] = "COLLECTION_UPDATE_FORM_VALUE";
    T["COLLECTION_REVISION_HISTORY"] = "COLLECTION_REVISION_HISTORY";
    T["COLLECTION_REVISION_HISTORY_ID"] = "COLLECTION_REVISION_HISTORY_ID";
    T["COLLECTION_REVISION_HISTORY_MODAL_TITLE"] = "COLLECTION_REVISION_HISTORY_MODAL_TITLE";
    T["COLLECTION_REVISION_HISTORY_MODAL_DESCRIPTION"] = "COLLECTION_REVISION_HISTORY_MODAL_DESCRIPTION";
    T["COLLECTION_REVISION_HISTORY_MODAL_REVERT"] = "COLLECTION_REVISION_HISTORY_MODAL_REVERT";
    T["COLLECTION_REVISION_HISTORY_MODAL_SUCCESS"] = "COLLECTION_REVISION_HISTORY_MODAL_SUCCESS";
    T["COLLECTION_REVISION_HISTORY_MODAL_FAILURE"] = "COLLECTION_REVISION_HISTORY_MODAL_FAILURE";
    T["COLLECTION_REVISION_HISTORY_REVERTED_MESSAGE"] = "COLLECTION_REVISION_HISTORY_REVERTED_MESSAGE";
    T["COLLECTION_REVISION_HISTORY_MOVED_FROM_DEPARTMENT_MESSAGE"] = "COLLECTION_REVISION_HISTORY_MOVED_FROM_DEPARTMENT_MESSAGE";
    T["COLLECTION_REVISION_HISTORY_FORM_MIGRATED_MESSAGE"] = "COLLECTION_REVISION_HISTORY_FORM_MIGRATED_MESSAGE";
    T["COLLECTION_INSIGHT_PROCESS"] = "COLLECTION_INSIGHT_PROCESS";
    T["COLLECTION_INSIGHT_PROCESS_CONFIRM"] = "COLLECTION_INSIGHT_PROCESS_CONFIRM";
    T["COLLECTION_INSIGHT_PROCESS_TITLE"] = "COLLECTION_INSIGHT_PROCESS_TITLE";
    T["COLLECTION_INSIGHT_PROCESS_SUCCESS"] = "COLLECTION_INSIGHT_PROCESS_SUCCESS";
    T["COLLECTION_INSIGHT_PROCESS_ERROR"] = "COLLECTION_INSIGHT_PROCESS_ERROR";
    T["COLLECTION_DELETE"] = "COLLECTION_DELETE";
    T["COLLECTION_DELETE_TITLE"] = "COLLECTION_DELETE_TITLE";
    T["COLLECTION_DELETE_CONFIRM"] = "COLLECTION_DELETE_CONFIRM";
    T["COLLECTION_DELETE_SUCCESS"] = "COLLECTION_DELETE_SUCCESS";
    T["COLLECTION_DELETE_BTN_TITLE"] = "COLLECTION_DELETE_BTN_TITLE";
    T["COLLECTION_DELETE_BTN_TITLE_DIRTY"] = "COLLECTION_DELETE_BTN_TITLE_DIRTY";
    T["COLLECTION_DELETE_REJECT"] = "COLLECTION_DELETE_REJECT";
    T["COLLECTION_EDIT"] = "COLLECTION_EDIT";
    T["COLLECTION_EDIT_ABORT"] = "COLLECTION_EDIT_ABORT";
    T["COLLECTION_EDIT_NO_CHANGES"] = "COLLECTION_EDIT_NO_CHANGES";
    T["COLLECTION_EDIT_SAVE_CHANGES"] = "COLLECTION_EDIT_SAVE_CHANGES";
    T["COLLECTION_EDIT_CREATE_SUBFORM"] = "COLLECTION_EDIT_CREATE_SUBFORM";
    T["COLLECTION_EDIT_DELETE_SUBFORM"] = "COLLECTION_EDIT_DELETE_SUBFORM";
    T["COLLECTION_EDIT_COPY_SUBFORM"] = "COLLECTION_EDIT_COPY_SUBFORM";
    T["COLLECTION_EDIT_COPY_SUBFORM_MEASUREMENTS"] = "COLLECTION_EDIT_COPY_SUBFORM_MEASUREMENTS";
    T["COLLECTION_EDIT_COPY_SUBFORM_SUCCESS"] = "COLLECTION_EDIT_COPY_SUBFORM_SUCCESS";
    T["COLLECTION_EDIT_SAVE_ERROR"] = "COLLECTION_EDIT_SAVE_ERROR";
    T["COLLECTION_IMPORT_CHOOSE_FORM"] = "COLLECTION_IMPORT_CHOOSE_FORM";
    T["COLLECTION_IMPORT_FORM"] = "COLLECTION_IMPORT_FORM";
    T["COLLECTION_IMPORT_CHOOSE_JOB"] = "COLLECTION_IMPORT_CHOOSE_JOB";
    T["COLLECTION_IMPORT_JOB"] = "COLLECTION_IMPORT_JOB";
    T["COLLECTION_IMPORT_MAP_FIELDS"] = "COLLECTION_IMPORT_MAP_FIELDS";
    T["COLLECTION_IMPORT_CHOOSE_FILE_TYPE"] = "COLLECTION_IMPORT_CHOOSE_FILE_TYPE";
    T["COLLECTION_IMPORT_EXCEL_TEMPLATE"] = "COLLECTION_IMPORT_EXCEL_TEMPLATE";
    T["COLLECTION_IMPORT_EXCEL_USER_GUIDE"] = "COLLECTION_IMPORT_EXCEL_USER_GUIDE";
    T["COLLECTION_IMPORT_EXCEL_USER_GUIDE_LINK"] = "COLLECTION_IMPORT_EXCEL_USER_GUIDE_LINK";
    T["COLLECTION_IMPORT_FILE_CSV"] = "COLLECTION_IMPORT_FILE_CSV";
    T["COLLECTION_IMPORT_FILE_EXCEL"] = "COLLECTION_IMPORT_FILE_EXCEL";
    T["COLLECTION_IMPORT_TOO_MANY"] = "COLLECTION_IMPORT_TOO_MANY";
    T["COLLECTION_IMPORT_FAILED"] = "COLLECTION_IMPORT_FAILED";
    T["COLLECTION_IMPORT_SUCCESS"] = "COLLECTION_IMPORT_SUCCESS";
    T["COLLECTION_IMPORT_GO"] = "COLLECTION_IMPORT_GO";
    T["COLLECTION_IMPORT_CHOOSE_CSV_MAPPING"] = "COLLECTION_IMPORT_CHOOSE_CSV_MAPPING";
    T["COLLECTION_IMPORT_TITLE"] = "COLLECTION_IMPORT_TITLE";
    T["COLLECTION_IMPORT_FIELD_INVALID"] = "COLLECTION_IMPORT_FIELD_INVALID";
    T["COLLECTION_IMPORT_NOT_ALLOWED"] = "COLLECTION_IMPORT_NOT_ALLOWED";
    T["COLLECTION_IMPORT_PROGRESS"] = "COLLECTION_IMPORT_PROGRESS";
    T["COLLECTION_LINK"] = "COLLECTION_LINK";
    T["COLLECTION_LINK_START"] = "COLLECTION_LINK_START";
    T["COLLECTION_LINK_CANCEL"] = "COLLECTION_LINK_CANCEL";
    T["COLLECTION_LINK_INVALID"] = "COLLECTION_LINK_INVALID";
    T["DISCARD_CHANGES_TITLE"] = "DISCARD_CHANGES_TITLE";
    T["DISCARD_CHANGES_CONFIRM"] = "DISCARD_CHANGES_CONFIRM";
    T["DISCARD_CHANGES_DISCARD"] = "DISCARD_CHANGES_DISCARD";
    T["DISTANCE_MISSING"] = "DISTANCE_MISSING";
    T["DISTANCE_VERTICAL"] = "DISTANCE_VERTICAL";
    T["DISTANCE_HORIZONTAL"] = "DISTANCE_HORIZONTAL";
    T["DISTANCE_VECTOR"] = "DISTANCE_VECTOR";
    T["DISTANCE_SAG"] = "DISTANCE_SAG";
    T["DEPARTMENT_SELECTOR_TITLE"] = "DEPARTMENT_SELECTOR_TITLE";
    T["DEPARTMENT_SELECTOR_ACCEPT"] = "DEPARTMENT_SELECTOR_ACCEPT";
    T["DEPARTMENT_SELECTOR_SUCCESS"] = "DEPARTMENT_SELECTOR_SUCCESS";
    T["DEPARTMENT_SELECTOR_CURRENT"] = "DEPARTMENT_SELECTOR_CURRENT";
    T["DEPARTMENT_SELECTOR_DISABLED"] = "DEPARTMENT_SELECTOR_DISABLED";
    T["DEPARTMENTS_DISABLED"] = "DEPARTMENTS_DISABLED";
    T["DISMISS"] = "DISMISS";
    T["INPUT_REQUIRED"] = "INPUT_REQUIRED";
    T["INVITE_ACCEPT_TITLE"] = "INVITE_ACCEPT_TITLE";
    T["INVITE_TOKEN_INVALID"] = "INVITE_TOKEN_INVALID";
    T["INVITE_TOKEN_OR"] = "INVITE_TOKEN_OR";
    T["INVITE_SUCCESS"] = "INVITE_SUCCESS";
    T["INVITE_VALID_PROMPT"] = "INVITE_VALID_PROMPT";
    T["INVITE_SSO_CREATION_SUCCESS"] = "INVITE_SSO_CREATION_SUCCESS";
    T["INVITE_SSO_FAILED"] = "INVITE_SSO_FAILED";
    T["INVITE_INVALID_ACCOUNT"] = "INVITE_INVALID_ACCOUNT";
    T["INVITE_LOGIN_HELP"] = "INVITE_LOGIN_HELP";
    T["INVITE_SIGNUP_HELP"] = "INVITE_SIGNUP_HELP";
    T["LINK_PHOTOMEASURE"] = "LINK_PHOTOMEASURE";
    T["LINK_MAP_WITH_COLLECTION"] = "LINK_MAP_WITH_COLLECTION";
    T["LINK_EDIT_TAG"] = "LINK_EDIT_TAG";
    T["LINK_COLLECTION_LIST"] = "LINK_COLLECTION_LIST";
    T["LINK_MAP_MODE"] = "LINK_MAP_MODE";
    /* Text shown after clicking the link button on a measurement */
    T["PHOTOMEASURE_JOIN"] = "PHOTOMEASURE_JOIN";
    T["PHOTOMEASURE_JOIN_START"] = "PHOTOMEASURE_JOIN_START";
    T["PHOTOMEASURE_LINK"] = "PHOTOMEASURE_LINK";
    T["PHOTOMEASURE_LINK_START"] = "PHOTOMEASURE_LINK_START";
    T["PHOTOMEASURE_DELETE_ALL_TITLE"] = "PHOTOMEASURE_DELETE_ALL_TITLE";
    T["PHOTOMEASURE_DELETE_ALL_TEXT"] = "PHOTOMEASURE_DELETE_ALL_TEXT";
    T["PHOTOMEASURE_HIDE_IMAGE_TITLE"] = "PHOTOMEASURE_HIDE_IMAGE_TITLE";
    T["PHOTOMEASURE_HIDE_IMAGE_TEXT"] = "PHOTOMEASURE_HIDE_IMAGE_TEXT";
    T["PHOTOMEASURE_UNHIDE_IMAGE_TITLE"] = "PHOTOMEASURE_UNHIDE_IMAGE_TITLE";
    T["PHOTOMEASURE_UNHIDE_IMAGE_TEXT"] = "PHOTOMEASURE_UNHIDE_IMAGE_TEXT";
    T["VERTICAL_SEPARATION_TOP"] = "VERTICAL_SEPARATION_TOP";
    T["VERTICAL_SEPARATION_BOTTOM"] = "VERTICAL_SEPARATION_BOTTOM";
    T["VERTICAL_SEPARATION_INVALID"] = "VERTICAL_SEPARATION_INVALID";
    T["BETA"] = "BETA";
    T["LEGACY"] = "LEGACY";
    T["EXPORT_MENU_TITLE"] = "EXPORT_MENU_TITLE";
    T["EXPORT_MENU_TITLE_DIRTY"] = "EXPORT_MENU_TITLE_DIRTY";
    T["EXPORT_MENU_TITLE_PERMISSION"] = "EXPORT_MENU_TITLE_PERMISSION";
    T["EXPORT_MENU_TITLE_LIMIT"] = "EXPORT_MENU_TITLE_LIMIT";
    T["EXPORTING_PDF_TITLE"] = "EXPORTING_PDF_TITLE";
    T["EXPORTING_PDF_CONTENT"] = "EXPORTING_PDF_CONTENT";
    T["EXPORT_KML"] = "EXPORT_KML";
    T["EXCEL"] = "EXCEL";
    T["EXCEL_BETA"] = "EXCEL_BETA";
    T["IMPORTABLE_EXCEL"] = "IMPORTABLE_EXCEL";
    T["CSV"] = "CSV";
    T["EXPORT_JSON"] = "EXPORT_JSON";
    T["EXPORT_REPORT"] = "EXPORT_REPORT";
    T["EXPORT_REPORT_SHORT"] = "EXPORT_REPORT_SHORT";
    T["EXPORT_REPORT_COMPOSITE_PHOTO"] = "EXPORT_REPORT_COMPOSITE_PHOTO";
    T["EXPORT_REPORT_COMPOSITE_PHOTO_ONLY"] = "EXPORT_REPORT_COMPOSITE_PHOTO_ONLY";
    T["EXPORT_REPORT_PHOTO"] = "EXPORT_REPORT_PHOTO";
    T["EXPORT_SPIDA_CALC"] = "EXPORT_SPIDA_CALC";
    T["EXPORT_SPIDA_CALC_NO_PHOTO"] = "EXPORT_SPIDA_NO_PHOTO";
    T["EXPORT_O_CALC"] = "EXPORT_O_CALC";
    T["EXPORT_POLEFOREMAN"] = "EXPORT_POLEFOREMAN";
    T["EXPORT_IKE_POLEFOREMAN"] = "EXPORT_IKE_POLEFOREMAN";
    T["EXPORT_IMAGE_ZIP"] = "EXPORT_IMAGE_ZIP";
    T["EXPORT_DDS"] = "EXPORT_DDS";
    T["EXPORT_NOT_EVERYTHING_EXPORTED"] = "EXPORT_NOT_EVERYTHING_EXPORTED";
    T["EXPORT_DEPRECATED"] = "EXPORT_DEPRECATED";
    T["FIELD_VECTOR_P2P_DISPLAY"] = "FIELD_VECTOR_DISPLAY";
    T["FILE_TOO_LARGE"] = "FILE_TOO_LARGE";
    T["FILE_DELETE"] = "FILE_DELETE";
    T["FILE_DELETE_TITLE"] = "FILE_DELETE_TITLE";
    T["FILE_DELETE_MESSAGE"] = "FILE_DELETE_MESSAGE";
    T["FILE_NOT_SUPPORTED"] = "FILE_NOT_SUPPORTED";
    T["FILE_INFECTED"] = "FILE_INFECTED";
    T["FORM_TITLE"] = "FORM_TITLE";
    T["FORM_NAME"] = "FORM_NAME";
    T["FORM_DESCRIPTION"] = "FORM_DESCRIPTION";
    T["FORM_VERSION"] = "FORM_VERSION";
    T["FORM_UPDATED_AT"] = "FORM_UPDATED_AT";
    T["FORM_EDIT"] = "FORM_EDIT";
    T["FORM_EDIT_TITLE"] = "FORM_EDIT_TITLE";
    T["FORM_CREATE"] = "FORM_CREATE";
    T["FORM_IMPORT"] = "FORM_IMPORT";
    T["FORM_IMPORT_POLEFOREMAN"] = "FORM_IMPORT_POLEFOREMAN";
    T["FORM_IMPORT_POLEFOREMAN_ERROR_DATABASE"] = "FORM_IMPORT_POLEFOREMAN_ERROR_DATABASE";
    T["FORM_IMPORT_POLEFOREMAN_OK"] = "FORM_IMPORT_POLEFOREMAN_OK";
    T["FORM_IMPORT_POLEFOREMAN_FETCHING_ORGS"] = "FORM_IMPORT_POLEFOREMAN_FETCHING_ORGS";
    T["FORM_IMPORT_POLEFOREMAN_SELECT_ORG"] = "FORM_IMPORT_POLEFOREMAN_SELECT_ORG";
    T["FORM_IMPORT_POLEFOREMAN_FETCHING_OP_CO"] = "FORM_IMPORT_POLEFOREMAN_FETCHING_OP_CO";
    T["FORM_IMPORT_POLEFOREMAN_ERROR_OP_CO"] = "FORM_IMPORT_POLEFOREMAN_ERROR_OP_CO";
    T["FORM_IMPORT_POLEFOREMAN_SINGLE_OP_CO"] = "FORM_IMPORT_POLEFOREMAN_SINGLE_OP_CO";
    T["FORM_IMPORT_POLEFOREMAN_SELECT_OP_CO"] = "FORM_IMPORT_POLEFOREMAN_SELECT_OP_CO";
    T["FORM_IMPORT_POLEFOREMAN_DESCRIPTION"] = "FORM_IMPORT_POLEFOREMAN_DESCRIPTION";
    T["FORM_IMPORT_POLEFOREMAN_OP_CO_DESCRIPTION"] = "FORM_IMPORT_POLEFOREMAN_OP_CO_DESCRIPTION";
    T["FORM_IMPORT_POLEFOREMAN_NO_DATABASES"] = "FORM_IMPORT_POLEFOREMAN_NO_DATABASES";
    T["FORM_IMPORT_POLEFOREMAN_NO_OPERATING_COMPANIES"] = "FORM_IMPORT_POLEFOREMAN_NO_OPERATING_COMPANIES";
    T["FORM_IMPORT_POLEFOREMAN_ERROR_CREATION"] = "FORM_IMPORT_POLEFOREMAN_ERROR_CREATION";
    T["FORM_IMPORT_UPLOAD_BUTTON"] = "FORM_IMPORT_UPLOAD_BUTTON";
    T["FORM_IMPORT_CONFIRM"] = "FORM_IMPORT_CONFIRM";
    T["FORM_IMPORT_SUCCEED"] = "FORM_IMPORT_SUCCEED";
    T["FORM_IMPORT_CHOOSE_FILE"] = "FORM_IMPORT_CHOOSE_FILE";
    T["FORM_NEW_POLEFOREMAN_FORM"] = "FORM_NEW_POLEFOREMAN_FORM";
    T["FORM_PLA_SUPPORT"] = "FORM_PLA_SUPPORT";
    T["FORM_LIST_ADD"] = "FORM_LIST_ADD";
    T["FORM_FIELD_ADD_HIDE"] = "FORM_FIELD_ADD_HIDE";
    T["FORM_FIELD_MOVE_UP"] = "FORM_FIELD_MOVE_UP";
    T["FORM_FIELD_MOVE_DOWN"] = "FORM_FIELD_MOVE_DOWN";
    T["FORM_FIELD_DISPLAY_NAME"] = "FORM_FIELD_DISPLAY_NAME";
    T["FORM_FIELD_ANNOTATION_LABEL_FIELD_ID"] = "FORM_FIELD_ANNOTATION_LABEL_FIELD_ID";
    T["FORM_FIELD_TYPE"] = "FORM_FIELD_TYPE";
    T["FORM_FIELD_DESCRIPTION"] = "FORM_FIELD_DESCRIPTION";
    T["FORM_OPTION_CLONEABLE"] = "FORM_OPTION_CLONEABLE";
    T["FORM_OPTION_CLONEABLE_TITLE"] = "FORM_OPTION_CLONEABLE_TITLE";
    T["FORM_OPTION_LABEL"] = "FORM_OPTION_LABEL";
    T["FORM_OPTION_LABEL_TITLE"] = "FORM_OPTION_LABEL_TITLE";
    T["FORM_OPTION_SECONDARY_LABEL"] = "FORM_OPTION_SECONDARY_LABEL";
    T["FORM_OPTION_HIDE"] = "FORM_OPTION_HIDE";
    T["FORM_OPTION_HIDE_TITLE"] = "FORM_OPTION_HIDE_TITLE";
    T["FORM_OPTION_LOCKED"] = "FORM_OPTION_LOCKED";
    T["FORM_OPTION_STATUS"] = "FORM_OPTION_STATUS";
    T["FORM_OPTION_MAP_COLOR"] = "FORM_OPTION_MAP_COLOR";
    T["FORM_OPTION_REQUIRED"] = "FORM_OPTION_REQUIRED";
    T["FORM_OPTION_ADDRESS"] = "FORM_OPTION_ADDRESS";
    T["FORM_FIELD_CHOOSE"] = "FORM_FIELD_CHOOSE";
    T["FORM_FIELD_ADD"] = "FORM_FIELD_ADD";
    T["FORM_FIELD_CANNOT_CHANGE"] = "FORM_FIELD_CANNOT_CHANGE";
    T["FORM_FIELD_DELETE"] = "FORM_FIELD_DELETE";
    T["FORM_FIELD_DELETE_TITLE"] = "FORM_FIELD_DELETE_TITLE";
    T["FORM_FIELD_DELETE_CONFIRM"] = "FORM_FIELD_DELETE_CONFIRM";
    T["FORM_FIELD_NESTED_LIST_DELETE"] = "FORM_FIELD_NESTED_LIST_DELETE";
    T["FORM_FIELD_NESTED_LIST_DELETE_TITLE"] = "FORM_FIELD_NESTED_LIST_DELETE_TITLE";
    T["FORM_FIELD_NESTED_LIST_DELETE_CONFIRM"] = "FORM_FIELD_NESTED_LIST_DELETE_CONFIRM";
    T["FORM_DELETE"] = "FORM_DELETE";
    T["FORM_DELETE_TITLE"] = "FORM_DELETE_TITLE";
    T["FORM_DELETE_CONFIRM"] = "FORM_DELETE_CONFIRM";
    T["FORM_DELETE_SUCCESS"] = "FORM_DELETE_SUCCESS";
    T["FORM_SHARE"] = "FORM_SHARE";
    T["FORM_SHARE_TITLE"] = "FORM_SHARE_TITLE";
    T["FORM_SHARE_CONFIRM"] = "FORM_SHARE_CONFIRM";
    T["FORM_SHARE_SUCCESS"] = "FORM_SHARE_SUCCESS";
    T["FORM_REFRESH"] = "FORM_REFRESH";
    T["FORM_REFRESH_MODAL_TITLE"] = "FORM_REFRESH_MODAL_TITLE";
    T["FORM_REFRESH_MODAL_TITLE_ERROR"] = "FORM_REFRESH_MODAL_TITLE_ERROR";
    T["FORM_REFRESH_MODAL_ERROR"] = "FORM_REFRESH_MODAL_ERROR";
    T["FORM_REFRESH_SUCCESS"] = "FORM_REFRESH_SUCCESS";
    T["FORM_NAME_MISSING"] = "FORM_NAME_MISSING";
    T["FORM_DESCRIPTION_MISSING"] = "FORM_DESCRIPTION_MISSING";
    T["FORM_ERROR_SAVING"] = "FORM_ERROR_SAVING";
    T["FORM_ERROR_DELETING"] = "FORM_ERROR_DELETING";
    T["FIELD_DISPLAY_NAME_MISSING"] = "FIELD_DISPLAY_NAME_MISSING";
    T["FIELD_TEXT"] = "FIELD_TEXT";
    T["FIELD_HEIGHT"] = "FIELD_HEIGHT";
    T["FIELD_NUMBER"] = "FIELD_NUMBER";
    T["FIELD_TRUE_SIZE"] = "FIELD_TRUE_SIZE";
    T["FIELD_DATE"] = "FIELD_DATE";
    T["FIELD_SELECT_LIST"] = "FIELD_SELECT_LIST";
    T["FIELD_YES_NO"] = "FIELD_YES_NO";
    T["FIELD_NESTED_LIST"] = "FIELD_NESTED_LIST";
    T["FIELD_NESTED_LIST_TITLE"] = "FIELD_NESTED_LIST_TITLE";
    T["FIELD_NESTED_LIST_VALUE"] = "FIELD_NESTED_LIST_VALUE";
    T["FIELD_FORM"] = "FIELD_FORM";
    T["FIELD_LOCATION"] = "FIELD_LOCATION";
    T["FIELD_LOCATION_ACCURACY"] = "FIELD_LOCATION_ACCURACY";
    T["FIELD_LOCATION_ALT"] = "FIELD_LOCATION_ALT";
    T["FIELD_LOCATION_ALT_IKE"] = "FIELD_LOCATION_ALT_IKE";
    T["FIELD_LOCATION_ALT_GROUND"] = "FIELD_LOCATION_ALT_GROUND";
    T["FIELD_LOCATION_ANTENNA_HEIGHT"] = "FIELD_LOCATION_ANTENNA_HEIGHT";
    T["FIELD_LOCATION_FIX"] = "FIELD_LOCATION_FIX";
    T["FIELD_LOCATION_FIX_DGPS"] = "FIELD_LOCATION_FIX_DGPS";
    T["FIELD_LOCATION_FIX_GPS"] = "FIELD_LOCATION_FIX_GPS";
    T["FIELD_LOCATION_FIX_PPS"] = "FIELD_LOCATION_FIX_PPS";
    T["FIELD_LOCATION_FIX_RTKFIXED"] = "FIELD_LOCATION_FIX_RTKFIXED";
    T["FIELD_LOCATION_FIX_RTKFLOAT"] = "FIELD_LOCATION_FIX_RTKFLOAT";
    T["FIELD_LOCATION_MANUAL"] = "FIELD_LOCATION_MANUAL";
    T["FIELD_LOCATION_EDITED"] = "FIELD_LOCATION_EDITED";
    T["FIELD_LOCATION_TRUESIZE"] = "FIELD_LOCATION_TRUESIZE";
    T["FIELD_LOCATION_GPS"] = "FIELD_LOCATION_GPS";
    T["FIELD_PROVIDER"] = "FIELD_PROVIDER";
    T["FIELD_IMAGE"] = "FIELD_IMAGE";
    T["FIELD_VECTOR"] = "FIELD_VECTOR";
    T["FIELD_ANCHOR"] = "FIELD_ANCHOR";
    T["FIELD_VECTOR_PROVIDER_MANUAL"] = "FIELD_VECTOR_PROVIDER_MANUAL";
    T["FIELD_VERTICAL_SEPARATION"] = "FIELD_VERTICAL_SEPARATION";
    T["FIELD_FILE_TOOL"] = "FIELD_FILE_TOOL";
    T["FIELD_FILE_TOOL_FILE_SIZE"] = "FIELD_FILE_TOOL_FILE_SIZE";
    T["FORM_NOT_FOUND"] = "FORM_NOT_FOUND";
    T["SELECT_LIST_TITLE"] = "SELECT_LIST_TITLE";
    T["SELECT_LIST_VALUE"] = "SELECT_LIST_VALUE";
    T["ANCHOR_ALIGNMENT_INLINE"] = "ANCHOR_ALIGNMENT_INLINE";
    T["ANCHOR_ALIGNMENT_BISECT"] = "ANCHOR_ALIGNMENT_BISECT";
    T["ANCHOR_ALIGNMENT_OTHER"] = "ANCHOR_ALIGNMENT_OTHER";
    T["LIST_MAP"] = "LIST_MAP";
    T["LIST_JOB_LIST"] = "LIST_JOB_LIST";
    T["LIST_FORM_LIST"] = "LIST_FORM_LIST";
    T["LIST_USER_ACCOUNTS"] = "LIST_USER_ACCOUNTS";
    T["LIST_COLLECTION_IMPORT"] = "LIST_COLLECTION_IMPORT";
    T["LOGIN"] = "LOGIN";
    T["LOGOUT"] = "LOGOUT";
    T["LOGIN_WITH_AUTH0"] = "LOGIN_WITH_AUTH0";
    T["LOGIN_NO_AUTH0_ACCOUNT"] = "LOGIN_NO_AUTH0_ACCOUNT";
    T["UNABLE_TO_START_SSO_SERVICE"] = "UNABLE_TO_START_SSO_SERVICE";
    T["LOGIN_OFFICE"] = "LOGIN_OFFICE";
    T["SSO_MIGRATE_EMAIL_SENT"] = "SSO_MIGRATE_EMAIL_SENT";
    T["SSO_MIGRATE_EMAIL_EXISTING"] = "SSO_MIGRATE_EMAIL_EXISTING";
    T["SSO_MIGRATE_FAILED"] = "SSO_MIGRATE_FAILED";
    T["SSO_UPGRADE_ACCOUNT"] = "SSO_UPGRADE_ACCOUNT";
    T["PASSWORD_CHANGE_PASSWORD"] = "PASSWORD_CHANGE_PASSWORD";
    T["PASSWORD_CHANGE_PASSWORD_DETAIL"] = "PASSWORD_CHANGE_PASSWORD_DETAIL";
    T["PASSWORD_FORGOT_TITLE"] = "PASSWORD_FORGOT_TITLE";
    T["PASSWORD_FORGOT_EMAIL"] = "PASSWORD_FORGOT_EMAIL";
    T["PASSWORD_FORGOT_ACCEPT"] = "PASSWORD_FORGOT_ACCEPT";
    T["PASSWORD_RESET_EMAIL_SENT"] = "PASSWORD_RESET_EMAIL_SENT";
    T["PASSWORD_FORGOT_SUCCESS"] = "PASSWORD_FORGOT_SUCCESS";
    T["PLA_SPIDACALC"] = "PLA_SPIDACALC";
    T["PLA_OCALC"] = "PLA_OCALC";
    T["PLA_DDS"] = "PLA_DDS";
    T["PLA_POLEFOREMAN"] = "PLA_POLEFOREMAN";
    T["PLA_IKE_POLEFOREMAN"] = "PLA_IKE_POLEFOREMAN";
    T["SPAN_O_MATIC"] = "SPAN_O_MATIC";
    T["PRINT"] = "PRINT";
    T["ME"] = "ME";
    T["MISSING_404_CODE"] = "MISSING_404_CODE";
    T["MISSING_404_TITLE"] = "MISSING_404_TITLE";
    T["MISSING_404_BEFORE_LINK"] = "MISSING_404_BEFORE_LINK";
    T["MISSING_404_LINK"] = "MISSING_404_LINK";
    T["MISSING_404_AFTER_LINK"] = "MISSING_404_AFTER_LINK";
    T["MISSING_403_CODE"] = "MISSING_403_CODE";
    T["MISSING_403_TITLE"] = "MISSING_403_TITLE";
    T["MISSING_403_BEFORE_LINK"] = "MISSING_403_BEFORE_LINK";
    T["MISSING_403_LINK"] = "MISSING_403_LINK";
    T["MISSING_403_AFTER_LINK"] = "MISSING_403_AFTER_LINK";
    T["MISSING_PAGE_NA"] = "MISSING_PAGE_NA";
    T["MULTI_ORG_MAP"] = "MULTI_ORG_MAP";
    T["NAVIGATE_MAP"] = "NAVIGATE_MAP";
    T["NO_LOCATION"] = "NO_LOCATION";
    T["NO_CAPTURES"] = "NO_CAPTURES";
    T["SELECT_CAPTURE"] = "SELECT_CAPTURE";
    T["NOTIFICATION_IN"] = "NOTIFICATION_IN";
    T["NOTIFICATION_ERROR_TITLE"] = "NOTIFICATION_ERROR_TITLE";
    T["NOTIFICATION_WARNING_TITLE"] = "NOTIFICATION_WARNING_TITLE";
    T["NOTIFICATION_CODE_REQUIRED"] = "NOTIFICATION_CODE_REQUIRED";
    T["NOTIFICATION_CODE_DEFAULT"] = "NOTIFICATION_CODE_DEFAULT";
    T["NOTIFICATION_CODE_INVALID"] = "NOTIFICATION_CODE_INVALID";
    T["NOTIFICATION_CODE_UNKNOWN"] = "NOTIFICATION_CODE_UNKNOWN";
    T["NOTIFICATION_REASON_AGL"] = "NOTIFICATION_REASON_AGL";
    T["NOTIFICATION_REASON_NO_LOCATION"] = "NOTIFICATION_REASON_NO_LOCATION";
    T["NOTIFICATION_REASON_NO_GUY_WIRE"] = "NOTIFICATION_REASON_NO_GUY_WIRE";
    T["NOTIFICATION_REASON_CLIENT_ITEM"] = "NOTIFICATION_REASON_CLIENT_ITEM";
    T["NOTIFICATION_REASON_OTHER"] = "NOTIFICATION_REASON_OTHER";
    T["NOTIFICATION_REASON_ONLY"] = "NOTIFICATION_REASON_ONLY";
    T["NOTIFICATION_REASON_MISSING"] = "NOTIFICATION_REASON_MISSING";
    T["REASON_IPF_ANCHOR_ASSEMBLY_TYPE_NOT_FOUND"] = "REASON_IPF_ANCHOR_ASSEMBLY_TYPE_NOT_FOUND";
    T["REASON_IPF_ANCHOR_LEAD_LENGTH_MISSING"] = "REASON_IPF_ANCHOR_LEAD_LENGTH_MISSING";
    T["REASON_IPF_ANCHOR_TOO_MANY_GUYS"] = "REASON_IPF_ANCHOR_TOO_MANY_GUYS";
    T["REASON_IPF_CONDUCTOR_TYPE_NOT_FOUND"] = "REASON_IPF_CONDUCTOR_TYPE_NOT_FOUND";
    T["REASON_IPF_CYCLE_DETECTED"] = "REASON_IPF_CYCLE_DETECTED";
    T["REASON_IPF_ISOLATED_POLES_DETECTED"] = "REASON_IPF_ISOLATED_POLES_DETECTED";
    T["REASON_IPF_EQUIPMENT_ATTACHMENT_HEIGHT_MISSING"] = "REASON_IPF_EQUIPMENT_ATTACHMENT_HEIGHT_MISSING";
    T["REASON_IPF_EQUIPMENT_ORIENTATION_MISSING"] = "REASON_IPF_EQUIPMENT_ORIENTATION_MISSING";
    T["REASON_IPF_EQUIPMENT_TYPE_NOT_FOUND"] = "REASON_IPF_EQUIPMENT_TYPE_NOT_FOUND";
    T["REASON_IPF_FRAMING_TYPE_NOT_FOUND"] = "REASON_IPF_FRAMING_TYPE_NOT_FOUND";
    T["REASON_IPF_GUY_ATTACHMENT_HEIGHT_MISSING"] = "REASON_IPF_GUY_ATTACHMENT_HEIGHT_MISSING";
    T["REASON_IPF_GUY_TYPE_NOT_FOUND"] = "REASON_IPF_GUY_TYPE_NOT_FOUND";
    T["REASON_IPF_GUY_INSULATOR_TYPE_NOT_FOUND"] = "REASON_IPF_GUY_INSULATOR_TYPE_NOT_FOUND";
    T["REASON_IPF_JOINT_USE_CABLE_TYPE_NOT_FOUND"] = "REASON_IPF_JOINT_USE_CABLE_TYPE_NOT_FOUND";
    T["REASON_IPF_MULTIPLE_SPANS_LINKED"] = "REASON_IPF_MULTIPLE_SPANS_LINKED";
    T["REASON_IPF_COLLECTION_LINK_ONE_WAY"] = "REASON_IPF_COLLECTION_LINK_ONE_WAY";
    T["REASON_IPF_MULTIPLE_SPANS_SAME_TYPE"] = "REASON_IPF_MULTIPLE_SPANS_SAME_TYPE";
    T["REASON_IPF_POWER_CIRCUIT_TYPE_NOT_FOUND"] = "REASON_IPF_POWER_CIRCUIT_TYPE_NOT_FOUND";
    T["REASON_IPF_SERVICE_CANNOT_BE_COLLECTION_LINKED"] = "REASON_IPF_SERVICE_CANNOT_BE_COLLECTION_LINKED";
    T["REASON_IPF_SERVICE_LENGTH_MISSING"] = "REASON_IPF_SERVICE_LENGTH_MISSING";
    T["REASON_IPF_SERVICE_ENDPOINT_MISSING"] = "REASON_IPF_SERVICE_ENDPOINT_MISSING";
    T["REASON_IPF_TARGET_COLLECTION_NOT_FOUND"] = "REASON_IPF_TARGET_COLLECTION_NOT_FOUND";
    T["REASON_IPF_SERVICE_MULTIPLE_POWER_CIRCUITS"] = "REASON_IPF_SERVICE_MULTIPLE_POWER_CIRCUITS";
    T["REASON_IPF_SERVICE_MULTIPLE_TELEPHONE_CABLES"] = "REASON_IPF_SERVICE_MULTIPLE_TELEPHONE_CABLES";
    T["REASON_IPF_SERVICE_MULTIPLE_CATV_CABLES"] = "REASON_IPF_SERVICE_MULTIPLE_CATV_CABLES";
    T["REASON_IPF_REQUIRED_FIELD"] = "REASON_IPF_REQUIRED_FIELD";
    T["REASON_IPF_POWER_CIRCUIT_NEEDS_GROUP"] = "REASON_IPF_POWER_CIRCUIT_NEEDS_GROUP";
    T["REASON_IPF_POWER_CIRCUIT_PRIMARY_PHASE_HEIGHT_MISSING"] = "REASON_IPF_POWER_CIRCUIT_PRIMARY_PHASE_HEIGHT_MISSING";
    T["REASON_IPF_POWER_CIRCUIT_SECONDARY_PHASE_HEIGHT_MISSING"] = "REASON_IPF_POWER_CIRCUIT_SECONDARY_PHASE_HEIGHT_MISSING";
    T["REASON_IPF_COUNT_ON_SPAN_MISMATCH"] = "REASON_IPF_COUNT_ON_SPAN_MISMATCH";
    T["REASON_IPF_SPAN_SAME_TYPE_LINKED"] = "REASON_IPF_SPAN_SAME_TYPE_LINKED";
    T["REASON_IPF_LOCATION_FALLBACK_TO_PHOTO"] = "REASON_IPF_LOCATION_FALLBACK_TO_PHOTO";
    T["REASON_DDS_REQUIRED_FIELD"] = "REASON_DDS_REQUIRED_FIELD";
    T["REASON_DDS_RECOMMENDED_FIELD"] = "REASON_DDS_RECOMMENDED_FIELD";
    T["REASON_DDS_LOCATION_FALLBACK_TO_PHOTO"] = "REASON_DDS_LOCATION_FALLBACK_TO_PHOTO";
    T["REASON_DDS_EQUIPMENT_TYPE_NOT_FOUND"] = "REASON_DDS_EQUIPMENT_TYPE_NOT_FOUND";
    T["NUMBER_INVALID"] = "NUMBER_INVALID";
    T["NUMBER_IMPRECISE"] = "NUMBER_IMPRECISE";
    T["ORG_SEARCH"] = "ORG_SEARCH";
    T["UNKNOWN"] = "UNKNOWN";
    T["USERNAME_INVALID"] = "USERNAME_INVALID";
    T["USER_MENU_FORM"] = "USER_MENU_FORM";
    T["USER_MENU_ACCOUNTS"] = "USER_MENU_ACCOUNTS";
    T["USER_MENU_SETTINGS"] = "USER_MENU_SETTINGS";
    T["USER_MENU_CHANGE_PASSWORD"] = "USER_MENU_CHANGE_PASSWORD";
    T["USER_MENU_LOGOUT"] = "USER_MENU_LOGOUT";
    T["REPORT_PRE_LOAD_TITLE"] = "REPORT_PRE_LOAD_TITLE";
    T["REPORT_PRE_LOAD_LOADING"] = "REPORT_PRE_LOAD_LOADING";
    T["REPORT_PRE_LOAD_INVALID_LICENSE"] = "REPORT_PRE_LOAD_INVALID_LICENSE";
    T["REPORT_COLLECTION_PLACE"] = "REPORT_COLLECTION_PLACE";
    T["REPORT_COLLECTION_VECTOR"] = "REPORT_COLLECTION_VECTOR";
    T["REPORT_COLLECTION_ANCHOR"] = "REPORT_COLLECTION_ANCHOR";
    T["REPORT_COLLECTION_LAT_LNG"] = "REPORT_COLLECTION_LAT_LNG";
    T["REPORT_COLLECTION_LAT_LNG_ALT"] = "REPORT_COLLECTION_LAT_LNG_ALT";
    T["ROLE_USER"] = "ROLE_USER";
    T["ROLE_ADMIN"] = "ROLE_ADMIN";
    T["ROLE_EDITOR"] = "ROLE_EDITOR";
    T["ROLE_DOWNLOADER"] = "ROLE_DOWNLOADER";
    T["ROLE_VIEWER"] = "ROLE_VIEWER";
    T["ROLE_DATA_ADMIN"] = "ROLE_DATA_ADMIN";
    T["SAVE"] = "SAVE";
    T["SELECT"] = "SELECT";
    T["SELECT_OPTION"] = "SELECT_OPTION";
    T["SELECT_MEASUREMENT"] = "SELECT_MEASUREMENT";
    T["SETTINGS_TITLE"] = "SETTINGS_TITLE";
    T["SETTINGS_DATE_FORMAT"] = "SETTINGS_DATE_FORMAT";
    T["SETTINGS_UNITS"] = "SETTINGS_UNITS";
    T["SETTINGS_DONE"] = "SETTINGS_DONE";
    T["SETTINGS_SAVED"] = "SETTINGS_SAVED";
    T["SETTINGS_ERROR_SAVING"] = "SETTINGS_ERROR_SAVING";
    T["SIGNUP"] = "SIGNUP";
    T["SIGNUP_EMAIL"] = "SIGNUP_EMAIL";
    T["SIGNUP_EMAIL_INVALID"] = "SIGNUP_EMAIL_INVALID";
    T["SIGNUP_FIRST_NAME"] = "SIGNUP_FIRST_NAME";
    T["SIGNUP_FIRST_NAME_INVALID"] = "SIGNUP_FIRST_NAME_INVALID";
    T["SIGNUP_LAST_NAME"] = "SIGNUP_LAST_NAME";
    T["SIGNUP_LAST_NAME_INVALID"] = "SIGNUP_LAST_NAME_INVALID";
    T["SUBMIT"] = "SUBMIT";
    T["BACK_TO_LOGIN"] = "BACK_TO_LOGIN";
    T["SORT_TITLE"] = "SORT_TITLE";
    T["SORT_DESCENDING"] = "SORT_DESCENDING";
    T["SORT_ASCENDING"] = "SORT_ASCENDING";
    T["SORT_FIELD_COLLECTED_AT"] = "SORT_FIELD_COLLECTED_AT";
    T["SORT_FIELD_COLLECTED_BY"] = "SORT_FIELD_COLLECTED_BY";
    T["SORT_FIELD_UPDATED_AT"] = "SORT_FIELD_UPDATED_AT";
    T["SORT_FIELD_NAME"] = "SORT_FIELD_NAME";
    T["SORT_FIELD_STATUS"] = "SORT_FIELD_STATUS";
    T["SORT_FIELD_ASSIGNED"] = "SORT_FIELD_ASSIGNED";
    T["SPAN"] = "SPAN";
    T["SPAN_LINK_TITLE"] = "SPAN_LINK_TITLE";
    T["SPAN_LINK_SELECT_CONTENT"] = "SPAN_LINK_SELECT_CONTENT";
    T["SPAN_LINK_SUCCESS"] = "SPAN_LINK_SUCCESS";
    T["SPAN_LINK_NO_MATCH"] = "SPAN_LINK_NO_MATCH";
    T["SUBFORM_REMOVE_TITLE"] = "SUBFORM_REMOVE_TITLE";
    T["SUBFORM_REMOVE_CONFIRM"] = "SUBFORM_REMOVE_CONFIRM";
    T["SUBFORM_REMOVE_REMOVE"] = "SUBFORM_REMOVE_REMOVE";
    T["TOOL_BASE"] = "TOOL_BASE";
    T["TOOL_SELECT"] = "TOOL_SELECT";
    T["TOOL_HEIGHT"] = "TOOL_HEIGHT";
    T["TOOL_WIDTH"] = "TOOL_WIDTH";
    T["TOOL_ARRANGE_ANNOTATIONS"] = "TOOL_ARRANGE_ANNOTATIONS";
    T["TOOL_CABLE_MEASURE"] = "TOOL_CABLE_MEASURE";
    T["TOOL_CABLE_MEASURE_INCREASE"] = "TOOL_CABLE_MEASURE_INCREASE";
    T["TOOL_CABLE_MEASURE_DECREASE"] = "TOOL_CABLE_MEASURE_DECREASE";
    T["TOOL_ZOOM_IN"] = "TOOL_ZOOM_IN";
    T["TOOL_ZOOM_OUT"] = "TOOL_ZOOM_OUT";
    T["TOOL_ZOOM_RESET"] = "TOOL_ZOOM_RESET";
    T["TOOL_BRIGHTNESS_INCREASE"] = "TOOL_BRIGHTNESS_INCREASE";
    T["TOOL_BRIGHTNESS_DECREASE"] = "TOOL_BRIGHTNESS_DECREASE";
    T["TOOL_BRIGHTNESS_RESET"] = "TOOL_BRIGHTNESS_RESET";
    T["TOOL_LASER_TOGGLE"] = "TOOL_LASER_TOGGLE";
    T["TOOL_INFO_TOGGLE"] = "TOOL_INFO_TOGGLE";
    T["TOOL_MEASUREMENTS_CLEAR"] = "TOOL_MEASUREMENTS_CLEAR";
    T["TOOL_DATE_TOGGLE"] = "TOOL_DATE_TOGGLE";
    T["TOOL_BEARING_TOGGLE"] = "TOOL_BEARING_TOGGLE";
    T["TOOL_INSIGHT_DETECTIONS_TOGGLE_MARKERS"] = "TOOL_INSIGHT_DETECTIONS_TOGGLE_MARKERS";
    T["TOOL_INSIGHT_DETECTIONS_TOGGLE_MASKS"] = "TOOL_INSIGHT_DETECTIONS_TOGGLE_MASKS";
    T["TOOL_INSIGHT_DETECTIONS_MARKERS_NONE"] = "TOOL_INSIGHT_DETECTIONS_MARKERS_NONE";
    T["TOOL_INSIGHT_DETECTIONS_MASKS_NONE"] = "TOOL_INSIGHT_DETECTIONS_MASKS_NONE";
    T["TOPO_TOOL_RELOCATE_POLE"] = "TOPO_TOOL_RELOCATE_POLE";
    T["TOPO_TOOL_SNAP"] = "TOPO_TOOL_SNAP";
    T["TOPO_SAVE_JOB"] = "TOPO_SAVE_JOB";
    T["TOPO_SUCCESS_SAVE_JOB"] = "TOPO_SUCCESS_SAVE_JOB";
    T["TOPO_UNSAVED_COLLECTION"] = "TOPO_UNSAVED_COLLECTION";
    T["TOPO_SHOW_HIDE_LABELS"] = "TOPO_SHOW_HIDE_LABELS";
    T["TOPO_SHOW_CAROUSEL"] = "TOPO_SHOW_CAROUSEL";
    T["TOPO_SHOW_COLLECTION_DATA"] = "TOPO_SHOW_COLLECTION_DATA";
    T["MAPMODE_LEGEND_DROPSPAN"] = "MAPMODE_LEGEND_DROPSPAN";
    T["MAPMODE_LEGEND_ANCHOR"] = "MAPMODE_LEGEND_ANCHOR";
    T["MAPMODE_LEGEND_SPAN"] = "MAPMODE_LEGEND_SPAN";
    T["MAPMODE_LEGEND_UNKNOWN"] = "MAPMODE_LEGEND_UNKNOWN";
    T["MAPMODE_LEGEND_COLLECTION_LABEL"] = "MAPMODE_LEGEND_COLLECTION_LABEL";
    T["MAPMODE_LEGEND_SELECTED_COLLECTION"] = "MAPMODE_LEGEND_SELECTED_COLLECTION";
    T["MAPMODE_LEGEND_LOCATION_RTK_FIXED"] = "MAPMODE_LEGEND_LOCATION_RTK_FIXED";
    T["MAPMODE_LEGEND_LOCATION_REVIEWED"] = "MAPMODE_LEGEND_LOCATION_REVIEWED";
    T["MAPMODE_LEGEND_LOCATION_RTK_FLOAT"] = "MAPMODE_LEGEND_LOCATION_RTK_FLOAT";
    T["MAPMODE_LEGEND_LOCATION_LOW_ACCURACY"] = "MAPMODE_LEGEND_LOCATION_LOW_ACCURACY";
    T["UNIT_SHORT_FEET"] = "UNIT_SHORT_FEET";
    T["UNIT_SHORT_INCH"] = "UNIT_SHORT_INCH";
    T["UNIT_SHORT_METER"] = "UNIT_SHORT_METER";
    T["UNIT_SHORT_DEGREE"] = "UNIT_SHORT_DEGREE";
    T["UNIT_METER"] = "UNIT_METER";
    T["UNIT_FEET_INCH"] = "UNIT_FEET_INCH";
    T["USER_ASSIGN_REQUIRED"] = "USER_ASSIGN_REQUIRED";
    T["YES"] = "YES";
    T["NO"] = "NO";
    T["LAT"] = "LAT";
    T["LNG"] = "LNG";
    T["ERROR"] = "error";
    T["CREATED"] = "created";
    T["UPDATED"] = "updated";
    T["SKIPPED"] = "skipped";
    T["TOOL_CROP_SET"] = "TOOL_CROP_SET";
    T["COLLECTION_DUPLICATE_TITLE"] = "COLLECTION_DUPLICATE_TITLE";
    T["COLLECTION_DUPLICATE"] = "COLLECTION_DUPLICATE";
    T["COLLECTION_DUPLICATE_CONFIRM"] = "COLLECTION_DUPLICATE_CONFIRM";
    T["COLLECTION_DUPLICATE_SUCCESS"] = "COLLECTION_DUPLICATE_SUCCESS";
    T["FORM_OPTION_ADMIN_ONLY"] = "FORM_OPTION_ADMIN_ONLY";
    T["FORM_OPTION_ADMIN_ONLY_TITLE"] = "FORM_OPTION_ADMIN_ONLY_TITLE";
    T["FORM_OPTION_STATUS_TITLE"] = "FORM_OPTION_STATUS_TITLE";
    T["FORM_OPTION_MAP_COLOR_TITLE"] = "FORM_OPTION_MAP_COLOR_TITLE";
    T["FORM_OPTION_REQUIRED_TITLE"] = "FORM_OPTION_REQUIRED_TITLE";
    T["FORM_OPTION_ADDRESS_TITLE"] = "FORM_OPTION_ADDRESS_TITLE";
    T["FILTER"] = "FILTER";
    T["MESSAGE_MOBILE_VALIDATION_TITLE"] = "MESSAGE_MOBILE_VALIDATION_TITLE";
    T["MESSAGE_MOBILE_VALIDATION_CONTENT"] = "MESSAGE_MOBILE_VALIDATION_CONTENT";
    T["MESSAGE_BROWSER_VALIDATION_TITLE"] = "MESSAGE_BROWSER_VALIDATION_TITLE";
    T["MESSAGE_BROWSER_VALIDATION_CONTENT"] = "MESSAGE_BROWSER_VALIDATION_CONTENT";
    T["MESSAGE_BROWSER_VALIDATION_URL"] = "MESSAGE_BROWSER_VALIDATION_URL";
    T["MESSAGE_BROWSER_VALIDATION_URL_TEXT"] = "MESSAGE_BROWSER_VALIDATION_URL_TEXT";
    T["LICENSE_CHECK_FAILED_TEXT"] = "LICENSE_CHECK_FAILED_TEXT";
    T["LICENSE_CHECK_FAILED_CONTACT_ADMIN_TEXT"] = "LICENSE_CHECK_FAILED_CONTACT_ADMIN_TEXT";
    T["LICENSE_CHECK_FAILED_CONTACT_ADMIN_EMAIL"] = "LICENSE_CHECK_FAILED_CONTACT_ADMIN_EMAIL";
    T["LICENSE_CHECK_FAILED_LINK"] = "LICENSE_CHECK_FAILED_LINK";
    T["REASON_SPIDA_CALC_TITLE_INVALID"] = "REASON_SPIDA_CALC_TITLE_INVALID";
    T["REASON_SPIDA_CALC_SPAN_LINKING_TARGET_POLE_NOT_FOUND"] = "REASON_SPIDA_CALC_SPAN_LINKING_TARGET_POLE_NOT_FOUND";
    T["REASON_SPIDA_CALC_SPAN_LINKING_SPAN_MISMATCH"] = "REASON_SPIDA_CALC_SPAN_LINKING_SPAN_MISMATCH";
    T["REASON_SPIDA_CALC_SPAN_LINKING_WIRES_COUNT_MISMATCH"] = "REASON_SPIDA_CALC_SPAN_LINKING_WIRES_COUNT_MISMATCH";
    T["REASON_SPIDA_CALC_SPAN_LINKING_WIRES_TOO_MANY"] = "REASON_SPIDA_CALC_SPAN_LINKING_WIRES_TOO_MANY";
    T["REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUYS_COUNT_MISMATCH"] = "REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUYS_COUNT_MISMATCH";
    T["REASON_SPIDA_CALC_SPAN_LINKING_WIRE_OWNER_MISMATCH"] = "REASON_SPIDA_CALC_SPAN_LINKING_WIRE_OWNER_MISMATCH";
    T["REASON_SPIDA_CALC_SPAN_LINKING_WIRE_USAGE_GROUP_MISMATCH"] = "REASON_SPIDA_CALC_SPAN_LINKING_WIRE_USAGE_GROUP_MISMATCH";
    T["REASON_SPIDA_CALC_SPAN_LINKING_WIRE_SIZE_MISMATCH"] = "REASON_SPIDA_CALC_SPAN_LINKING_WIRE_SIZE_MISMATCH";
    T["REASON_SPIDA_CALC_SPAN_LINKING_WIRE_TENSION_GROUP_MISMATCH"] = "REASON_SPIDA_CALC_SPAN_LINKING_WIRE_TENSION_GROUP_MISMATCH";
    T["REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUY_OWNER_MISMATCH"] = "REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUY_OWNER_MISMATCH";
    T["REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUY_USAGE_GROUP_MISMATCH"] = "REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUY_USAGE_GROUP_MISMATCH";
    T["REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUY_SIZE_MISMATCH"] = "REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUY_SIZE_MISMATCH";
    T["REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUY_TENSION_GROUP_MISMATCH"] = "REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUY_TENSION_GROUP_MISMATCH";
    T["REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUY_ATTACHMENT_HEIGHT_EXCEED_AGL"] = "REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUY_ATTACHMENT_HEIGHT_EXCEED_AGL";
    T["REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUY_MID_SPAN_HEIGHT_EXCEED_AGL"] = "REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUY_MID_SPAN_HEIGHT_EXCEED_AGL";
    T["REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUY_HEIGHT_EXCEED_AGL"] = "REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUY_HEIGHT_EXCEED_AGL";
    T["REASON_EXPORT_IMPORTABLE_EXCEL_MULTIPLE_FORM_VERSIONS"] = "EXPORT_IMPORTABLE_EXCEL_MULTIPLE_FORM_VERSIONS";
    T["REASON_EXPORT_IMPORTABLE_EXCEL_TOO_MANY_COLLECTIONS"] = "EXPORT_IMPORTABLE_EXCEL_TOO_MANY_COLLECTIONS";
    T["REASON_EXPORT_IMPORTABLE_EXCEL_CELL_FORMAT_MISMATCH_STRING"] = "REASON_EXPORT_IMPORTABLE_EXCEL_CELL_FORMAT_MISMATCH_STRING";
    T["REASON_EXPORT_IMPORTABLE_EXCEL_CELL_FORMAT_MISMATCH_LATITUDE"] = "REASON_EXPORT_IMPORTABLE_EXCEL_CELL_FORMAT_MISMATCH_LATITUDE";
    T["REASON_EXPORT_IMPORTABLE_EXCEL_CELL_FORMAT_MISMATCH_LONGITUDE"] = "REASON_EXPORT_IMPORTABLE_EXCEL_CELL_FORMAT_MISMATCH_LONGITUDE";
    T["REASON_EXPORT_IMPORTABLE_EXCEL_CELL_FORMAT_MISMATCH_NUMBER"] = "REASON_EXPORT_IMPORTABLE_EXCEL_CELL_FORMAT_MISMATCH_NUMBER";
    T["REASON_EXPORT_IMPORTABLE_EXCEL_CELL_FORMAT_MISMATCH_BOOLEAN"] = "REASON_EXPORT_IMPORTABLE_EXCEL_CELL_FORMAT_MISMATCH_BOOLEAN";
    T["REASON_EXPORT_IMPORTABLE_EXCEL_CELL_FORMAT_MISMATCH_ANCHOR"] = "REASON_EXPORT_IMPORTABLE_EXCEL_CELL_FORMAT_MISMATCH_ANCHOR";
    T["REASON_EXPORT_IMPORTABLE_EXCEL_CELL_FORMAT_MISMATCH_LENGTH"] = "REASON_EXPORT_IMPORTABLE_EXCEL_CELL_FORMAT_MISMATCH_LENGTH";
    T["REASON_EXPORT_IMPORTABLE_EXCEL_CELL_FORMAT_MISMATCH_LENGTH_IMPERIAL"] = "REASON_EXPORT_IMPORTABLE_EXCEL_CELL_FORMAT_MISMATCH_LENGTH_IMPERIAL";
    T["REASON_EXPORT_IMPORTABLE_EXCEL_FORM_ID_MISMATCH"] = "REASON_EXPORT_IMPORTABLE_EXCEL_FORM_ID_MISMATCH";
    T["REASON_EXPORT_IMPORTABLE_EXCEL_FORM_REVISION_MISMATCH"] = "REASON_EXPORT_IMPORTABLE_EXCEL_FORM_REVISION_MISMATCH";
    T["REASON_EXPORT_IMPORTABLE_EXCEL_INVALID_DATE_FORMAT"] = "REASON_EXPORT_IMPORTABLE_EXCEL_INVALID_DATE_FORMAT";
    T["REASON_EXPORT_IMPORTABLE_EXCEL_OPTION_DOES_NOT_EXIST"] = "REASON_EXPORT_IMPORTABLE_EXCEL_OPTION_DOES_NOT_EXIST";
    T["IMPORT_FILE_NO_ROWS"] = "IMPORT_FILE_NO_ROWS";
    T["HELP_MENU"] = "HELP_MENU";
    T["SUBMIT_SUPPORT_REQUEST"] = "SUBMIT_SUPPORT_REQUEST";
    T["SUPPORT_PORTAL"] = "SUPPORT_PORTAL";
    T["RELEASE_NOTES"] = "RELEASE_NOTES";
    T["REVISION_ID"] = "REVISION_ID";
    T["MODIFIED_AT"] = "MODIFIED_AT";
    T["MODIFIED_BY"] = "MODIFIED_BY";
    T["MODIFICATIONS"] = "MODIFICATIONS";
})(T || (exports.T = T = {}));
exports.CURRENT_LANG = 'en-us';
exports.TRANSLATIONS = {
    'en-us': (_a = {},
        _a[T.EMPTY] = '',
        _a[T.IKE_OFFICE] = 'IKE Office',
        _a[T.IKE_OFFICE_PRO] = 'IKE Office Pro',
        _a[T.ACCOUNT_LOCKED] = 'Your account has been locked due to multiple invalid login attempts. You can try again later or reset your password now.',
        _a[T.ACCOUNTS_TITLE] = 'Users',
        _a[T.ACCOUNTS_USERNAME] = 'Username',
        _a[T.ACCOUNTS_NAME] = 'Name',
        _a[T.ACCOUNTS_ROLE] = 'Role',
        _a[T.ACCOUNTS_INVITES_PENDING] = 'Pending Invites',
        _a[T.ACCOUNTS_NO_INVITES_PENDING] = 'No Pending Invites',
        _a[T.ACCOUNTS_INVITE_EXPIRES] = 'Expires At',
        _a[T.ACCOUNTS_INVITE] = 'Invite',
        _a[T.ACCOUNTS_INVITE_TITLE] = 'Invite New Users',
        _a[T.ACCOUNTS_INVITE_CONFIRM] = 'Email address to invite. Separate multiple email addresses with a comma.',
        _a[T.ACCOUNTS_INVITE_SUCCESS] = 'Invites Sent',
        _a[T.ACCOUNTS_ADDED_USER] = 'Added user(s) to department',
        _a[T.ACCOUNTS_INVITE_EXISTING_USER] = function (usernames) {
            return "Cannot invite existing users: ".concat(usernames.join(','));
        },
        _a[T.ACCOUNTS_INVITE_INVALID_USER] = function (usernames) {
            return "Cannot invite invalid users: ".concat(usernames.join(','));
        },
        _a[T.ACCOUNTS_INVITE_MAX] = function (max) {
            return "You can only make up to ".concat(max, " invites at one time.");
        },
        _a[T.ACCOUNTS_INVITE_CHOOSE_USER_ROLE] = 'Please choose user role',
        _a[T.ACCOUNTS_REMOVE] = 'Remove',
        _a[T.ACCOUNTS_REMOVE_TITLE] = 'Remove User',
        _a[T.ACCOUNTS_REMOVE_CONFIRM] = function (username) {
            return "Are you sure you would like to remove '".concat(username, "'?");
        },
        _a[T.ACCOUNTS_REMOVE_SUCCESS] = 'User Removed',
        _a[T.ACCOUNTS_REVOKE] = 'Revoke',
        _a[T.ACCOUNTS_REVOKE_TITLE] = 'Revoke User Invite',
        _a[T.ACCOUNTS_REVOKE_CONFIRM] = function (username) {
            return "Are you sure you would like to revoke invite to '".concat(username, "'?");
        },
        _a[T.ACCOUNTS_REVOKE_SUCCESS] = 'Invite has been revoked',
        _a[T.ACCOUNTS_DEMOTE] = 'Demote',
        _a[T.ACCOUNTS_DEMOTE_TITLE] = 'Demote User',
        _a[T.ACCOUNTS_DEMOTE_CONFIRM] = function (username) {
            return "Are you sure want to demote ".concat(username, " from admin?");
        },
        _a[T.ACCOUNTS_DEMOTE_SUCCESS] = 'User Demoted from Admin',
        _a[T.ACCOUNTS_PROMOTE] = 'Promote',
        _a[T.ACCOUNTS_PROMOTE_TITLE] = 'Promote User',
        _a[T.ACCOUNTS_PROMOTE_CONFIRM] = function (username) {
            return "Are you sure want to promote ".concat(username, " to admin?");
        },
        _a[T.ACCOUNTS_PROMOTE_SUCCESS] = 'User Promoted to Admin',
        _a[T.ACCOUNTS_SET_ROLE] = 'Set Role',
        _a[T.ACCOUNTS_SET_ROLE_TITLE] = 'Set User Role',
        _a[T.ACCOUNTS_SET_ROLE_CONFIRM] = function (_a) {
            var username = _a.username, role = _a.role;
            return "Are you sure want to set ".concat(username, "'s role to ").concat(role, "?");
        },
        _a[T.ACCOUNTS_SET_ROLE_SUCCESS] = 'User has a new role',
        _a[T.AUTH0_WARNING] = 'Changes are coming to how you login to IKE Office and IKE Field. Please read more ',
        _a[T.BANNER_MESSAGE_PT1] = 'Having trouble logging in? Click ',
        _a[T.BANNER_MESSAGE_PT2] = ' for instructions on the new IKE ID',
        _a[T.OK] = 'Ok',
        _a[T.CANCEL] = 'Cancel',
        _a[T.NEXT] = 'Next',
        _a[T.CLOSE] = 'Close',
        _a[T.CONTINUE] = 'Continue',
        _a[T.HERE] = 'HERE',
        _a[T.SEND] = 'Send',
        _a[T.TRY_AGAIN] = 'Try again',
        _a[T.ACCEPT] = 'Accept',
        _a[T.COLOR] = 'Color',
        _a[T.ALTITUDE_MISSING] = 'Altitude missing',
        _a[T.LATITUDE_MISSING] = 'Latitude missing',
        _a[T.LONGITUDE_MISSING] = 'Longitude missing',
        _a[T.BEARING_INVALID] = 'Invalid bearing',
        _a[T.BEARING_MISSING] = 'Missing bearing',
        _a[T.PLACEMENT_MISSING] = 'Missing placement',
        _a[T.ACCURATE_ANCHOR_RELATED_SPAN_NO_VALUE] = 'The selected span(s) do not have a bearing specified',
        _a[T.ACCURATE_ANCHOR_RELATED_SPAN_NO_SELECTION_BISECT] = 'A bisect placement requires both spans to be selected',
        _a[T.ACCURATE_ANCHOR_RELATED_SPAN_NO_SELECTION_INLINE] = 'An inline placement requires a span to be select',
        _a[T.LOCATION_FIELD_OUT_OF_RANGE] = function (_a) {
            var field = _a.field, maxValue = _a.maxValue;
            return "".concat(field, " between -").concat(maxValue, " and ").concat(maxValue, " required");
        },
        _a[T.DATE_INVALID] = 'Invalid date',
        _a[T.DEPARTMENT] = 'Department',
        _a[T.EMAIL_INVALID] = 'Invalid Email',
        _a[T.EMAIL_EXISTS_IN_DEPARTMENT] = 'You are already logged in as a member.',
        _a[T.ENTER_VALID_EMAIL] = 'Please enter a valid email address',
        _a[T.USER_ALREADY_EXISTS] = 'User already exists',
        _a[T.USER_ALREADY_EXISTS_DESCRIPTION] = 'A user with this email address already exists. Try logging in.',
        _a[T.ERROR_GENERAL] = 'An error occurred',
        _a[T.ERROR_EXPORT] = 'There was an error exporting your collections',
        _a[T.ERROR_INFECTED] = 'Virus found. Contact support',
        _a[T.ERROR_DOWNLOAD_FAIL] = 'Could not download file. Contact support.',
        _a[T.LOADING] = 'Loading...',
        _a[T.LOAD_MORE] = 'Load more',
        _a[T.INVITE_ACCEPT_TITLE] = 'Accept Invite',
        _a[T.INVITE_TOKEN_INVALID] = 'This invite link is invalid.',
        _a[T.INVITE_TOKEN_OR] = 'OR',
        _a[T.INVITE_SUCCESS] = 'Success',
        _a[T.INVITE_VALID_PROMPT] = 'Accept the department invite using the button below.',
        _a[T.INVITE_SSO_CREATION_SUCCESS] = 'Welcome to IKE Office. You will receive an email shortly where you can set a password. Once you have completed that, you can then login with the button below.',
        _a[T.INVITE_SSO_FAILED] = 'An error has occurred, please try again. If this happens again please contact support.',
        _a[T.INVITE_INVALID_ACCOUNT] = 'This account does not match the invited account. Please login with the correct account and try the invite link again.',
        _a[T.INVITE_LOGIN_HELP] = 'Already an IKE Office user?',
        _a[T.INVITE_SIGNUP_HELP] = 'New to IKE Office?',
        _a[T.LINK_PHOTOMEASURE] = 'PhotoMeasure collections',
        _a[T.LINK_COLLECTION_LIST] = 'Edit Collection List',
        _a[T.LINK_MAP_MODE] = 'Edit job in Map Based Review Mode',
        _a[T.LINK_EDIT_TAG] = 'Edit job name',
        _a[T.LINK_MAP_WITH_COLLECTION] = 'View collection details in the Big Map',
        _a[T.DRAWABLE_BASE_OFFSET] = 'Base offset',
        _a[T.DRAWABLE_TITLE] = 'Title',
        _a[T.STATUS] = 'Status',
        _a[T.DASHBOARD_POLE_LOADING] = 'Pole Loading',
        _a[T.DASHBOARD_POLE_STATUS] = 'Pole Status',
        _a[T.DASHBOARD] = 'Dashboard',
        _a[T.COLLECTION_TITLE] = 'Collections',
        _a[T.CLOSE_WINDOW] = 'Close Window',
        _a[T.COLLECTION_MISSING] = 'Collection not found',
        _a[T.COLLECTION_MISSING_TITLE] = 'No title',
        _a[T.COLLECTION_COLLECTED_AT] = 'Collected at',
        _a[T.COLLECTION_COLLECTED_BY] = 'Collected by',
        _a[T.COLLECTION_UPDATED_AT] = 'Last modified',
        _a[T.COLLECTION_UPDATED_BY] = 'Last modified by',
        _a[T.COLLECTION_ASSIGNED_TO] = 'Assigned to',
        _a[T.COLLECTION_FORM_NAME] = 'Form',
        _a[T.COLLECTION_FORM_VERSION] = 'Form version',
        _a[T.COLLECTION_EXPAND_ALL] = 'Expand all',
        _a[T.COLLECTION_COLLAPSE_ALL] = 'Collapse all',
        _a[T.COLLECTION_ASSIGN] = 'Assign',
        _a[T.COLLECTION_UNASSIGNED] = 'Unassigned',
        _a[T.COLLECTION_ASSIGN_TITLE] = 'Assign Collections',
        _a[T.COLLECTION_ASSIGN_CONFIRM] = function (_a) {
            var count = _a.count;
            return "Assign ".concat(count, " ").concat(count === 1 ? 'collection' : 'collections', " to:");
        },
        _a[T.COLLECTION_ASSIGN_SUCCESS] = function (_a) {
            var count = _a.count;
            return "".concat(count, " ").concat(count === 1 ? 'collection' : 'collections', " re-assigned");
        },
        _a[T.COLLECTION_MOVE] = 'Move',
        _a[T.COLLECTION_MOVE_TITLE] = 'Move Collections',
        _a[T.COLLECTION_MOVE_CONFIRM] = function (_a) {
            var count = _a.count;
            return "Move ".concat(count, " ").concat(count === 1 ? 'collection' : 'collections', " to:");
        },
        _a[T.COLLECTION_MOVE_SUCCESS] = function (_a) {
            var count = _a.count;
            return "".concat(count, " ").concat(count === 1 ? 'collection' : 'collections', " moved");
        },
        _a[T.COLLECTION_MOVE_JOB] = 'Move to Job',
        _a[T.COLLECTION_MOVE_JOB_TITLE] = 'Move Collections to Job',
        _a[T.COLLECTION_MOVE_JOB_INPUT_ERROR] = 'You need a Job name to move Collections to',
        _a[T.COLLECTION_MOVE_DEPARTMENT] = 'Move to Department',
        _a[T.COLLECTION_DUPLICATE] = 'Duplicate',
        _a[T.COLLECTION_DUPLICATE_TITLE] = 'Duplicate Collections',
        _a[T.COLLECTION_DUPLICATE_CONFIRM] = function (_a) {
            var count = _a.count;
            return "Are you sure you would like to duplicate ".concat(count, " ").concat(count === 1 ? 'collection' : 'collections', "?");
        },
        _a[T.COLLECTION_DUPLICATE_SUCCESS] = function (_a) {
            var count = _a.count;
            return "".concat(count, " ").concat(count === 1 ? 'collection' : 'collections', " duplicated");
        },
        _a[T.COLLECTION_STATUS] = 'Set Status',
        _a[T.CLEAR_COLLECTION_STATUS] = 'Clear Status',
        _a[T.COLLECTION_STATUS_TITLE] = 'Set Collection Status',
        _a[T.COLLECTION_STATUS_CONFIRM] = function (_a) {
            var count = _a.count;
            return "Set status for ".concat(count, " ").concat(count === 1 ? 'collection' : 'collections', " to:");
        },
        _a[T.COLLECTION_STATUS_SUCCESS] = function (_a) {
            var count = _a.count;
            return "".concat(count, " ").concat(count === 1 ? 'collection' : 'collections', " got new status");
        },
        _a[T.COLLECTION_STATUS_CANNOT_CHANGE] = function (_a) {
            var count = _a.count;
            return "Can't change: ".concat(count);
        },
        _a[T.COLLECTION_MIGRATE_FORM] = 'Migrate Form',
        _a[T.COLLECTION_MIGRATE_FORM_TITLE] = 'Form migration',
        _a[T.COLLECTION_MIGRATE_FORM_SUCCESS] = 'Successfully migrated collection forms',
        _a[T.COLLECTION_MIGRATE_FORM_FAIL] = 'Failed to migrate. Please try again later',
        _a[T.COLLECTION_MIGRATE_FORM_BODY_WARNING_TITLE] = 'WARNING: Data may be lost during Form migration',
        _a[T.COLLECTION_MIGRATE_FORM_BODY_WARNING_DESCRIPTION_PT1] = 'When migrating Forms, any data that doesn\'t have a matching field or matching value option in the target Form will be deleted.',
        _a[T.COLLECTION_MIGRATE_FORM_BODY_WARNING_DESCRIPTION_PT2] = 'To prevent data loss:',
        _a[T.COLLECTION_MIGRATE_FORM_BODY_WARNING_DESCRIPTION_PT3] = 'Consider duplicating your poles first to preserve all information, and only migrate one set of them.',
        _a[T.COLLECTION_MIGRATE_FORM_BODY_WARNING_DESCRIPTION_PT4] = 'If needed, you can restore data using each pole\'s revision history, but note this can be time-consuming.',
        _a[T.COLLECTION_MIGRATE_FORM_BODY] = 'Choose a form to migrate the selected collections to:',
        _a[T.COLLECTION_MIGRATE_FORM_BODY_NO_FORMS] = 'No forms available for migration',
        _a[T.COLLECTION_UPDATE_FORM] = 'Update Form',
        _a[T.COLLECTION_UPDATE_FORM_TITLE] = 'Update Collection Form',
        _a[T.COLLECTION_UPDATE_FORM_CONFIRM] = function (_a) {
            var count = _a.count;
            return "Update form for ".concat(count, " ").concat(count === 1 ? 'collection' : 'collections');
        },
        _a[T.COLLECTION_UPDATE_FORM_ERROR_TITLE] = function (_a) {
            var count = _a.count;
            return "Can't update the collections because of ".concat(count, " ").concat(count === 1 ? 'error' : 'errors');
        },
        _a[T.COLLECTION_UPDATE_FORM_FIELD_MISSING] = 'Field is missing in new form',
        _a[T.COLLECTION_UPDATE_FORM_FIELD_VALUE_MISSING] = 'Field value is missing in new form',
        _a[T.COLLECTION_UPDATE_FORM_REASON] = 'Reason',
        _a[T.COLLECTION_UPDATE_FORM_VALUE] = 'Value',
        _a[T.COLLECTION_UPDATE_FORM_FIELD_NAME] = 'Field Name',
        _a[T.COLLECTION_UPDATE_FORM_SUCCESS] = 'Successfully updated forms.',
        _a[T.COLLECTION_UPDATE_FORM_CURRENT_REVISION] = 'Current Form Revision',
        _a[T.COLLECTION_UPDATE_FORM_LATEST_REVISION] = 'Latest Form Revision',
        _a[T.COLLECTION_UPDATE_FORM_ERROR] = 'Form update error',
        _a[T.COLLECTION_UPDATE_HAS_LATEST_FORM] = 'Latest form',
        _a[T.COLLECTION_REVISION_HISTORY] = 'Revision History',
        _a[T.COLLECTION_REVISION_HISTORY_ID] = function (collectionName) { return "Revision History: ".concat(collectionName); },
        _a[T.COLLECTION_REVISION_HISTORY_MODAL_TITLE] = function (_a) {
            var collectionName = _a.collectionName, revisionId = _a.revisionId;
            return "Revert Collection ".concat(collectionName, " to revision ").concat(revisionId);
        },
        _a[T.COLLECTION_REVISION_HISTORY_MODAL_DESCRIPTION] = 'Are you sure you want to revert this collection?',
        _a[T.COLLECTION_REVISION_HISTORY_MODAL_REVERT] = 'Revert',
        _a[T.COLLECTION_REVISION_HISTORY_MODAL_SUCCESS] = 'Collection successfully reverted',
        _a[T.COLLECTION_REVISION_HISTORY_MODAL_FAILURE] = 'Collection revert failed',
        _a[T.COLLECTION_REVISION_HISTORY_REVERTED_MESSAGE] = function (departmentName) { return "Reverted to revision ".concat(departmentName); },
        _a[T.COLLECTION_REVISION_HISTORY_MOVED_FROM_DEPARTMENT_MESSAGE] = function (collectionRevisionId) { return "Moved from ".concat(collectionRevisionId); },
        _a[T.COLLECTION_REVISION_HISTORY_FORM_MIGRATED_MESSAGE] = function (_a) {
            var from = _a.from, to = _a.to;
            return "Form migrated from ".concat(from, " to ").concat(to);
        },
        _a[T.COLLECTION_INSIGHT_PROCESS] = 'Run PolePilot',
        _a[T.COLLECTION_INSIGHT_PROCESS_TITLE] = 'Run PolePilot Processing',
        _a[T.COLLECTION_INSIGHT_PROCESS_CONFIRM] = function (count) {
            return "Please confirm that you would like to request PolePilot detections processing for the ".concat(count, " selected collection(s).\n\n            If the department is correctly configured for processing PolePilot detections, these collections will be added to a queue for processing.\n\n            Generally, detections should be available within 12 hours.");
        },
        _a[T.COLLECTION_INSIGHT_PROCESS_SUCCESS] = 'PolePilot processing requests sent!',
        _a[T.COLLECTION_INSIGHT_PROCESS_ERROR] = 'An error occurred while processing collections with PolePilot: ',
        _a[T.COLLECTION_DELETE] = 'Delete',
        _a[T.COLLECTION_DELETE_TITLE] = 'Delete Collections',
        _a[T.COLLECTION_DELETE_CONFIRM] = function (count) {
            return "Are you sure you would like to delete ".concat(count, " ").concat(count === 1 ? 'collection' : 'collections', "?");
        },
        _a[T.COLLECTION_DELETE_SUCCESS] = function (_a) {
            var count = _a.count;
            return "".concat(count, " ").concat(count === 1 ? 'collection' : 'collections', " deleted");
        },
        _a[T.COLLECTION_DELETE_BTN_TITLE] = 'Delete selected collections',
        _a[T.COLLECTION_DELETE_BTN_TITLE_DIRTY] = 'Please save your changes before deleting.',
        _a[T.COLLECTION_DELETE_REJECT] = function (_a) {
            var max = _a.max;
            return "Cannot delete more than ".concat(max, " jobs at once");
        },
        _a[T.COLLECTION_SHOW_META] = 'Show collection information',
        _a[T.COLLECTION_SHOW_ZOOM] = 'Show attachment preview',
        _a[T.COLLECTION_IMPORT_PROGRESS] = function (_a) {
            var count = _a.count, total = _a.total;
            return "Importing ".concat(count, " of ").concat(total, "...");
        },
        _a[T.COLLECTION_LINK] = 'Collection Link',
        _a[T.COLLECTION_LINK_START] = 'Select a collection on the map to link to',
        _a[T.COLLECTION_LINK_CANCEL] = 'Cancel Collection Link',
        _a[T.COLLECTION_LINK_INVALID] = 'Cannot link to same collection',
        _a[T.COLLECTION_EDIT] = 'Edit collection',
        _a[T.COLLECTION_EDIT_ABORT] = 'Discard changes',
        _a[T.COLLECTION_EDIT_NO_CHANGES] = 'No changes',
        _a[T.COLLECTION_EDIT_SAVE_CHANGES] = 'Save changes',
        _a[T.COLLECTION_EDIT_CREATE_SUBFORM] = function (_a) {
            var title = _a.title;
            return "Add new ".concat(title);
        },
        _a[T.COLLECTION_EDIT_DELETE_SUBFORM] = function (_a) {
            var title = _a.title;
            return "Remove ".concat(title);
        },
        _a[T.COLLECTION_EDIT_COPY_SUBFORM] = function (_a) {
            var title = _a.title;
            return "Duplicate ".concat(title);
        },
        _a[T.COLLECTION_EDIT_COPY_SUBFORM_MEASUREMENTS] = function (_a) {
            var title = _a.title;
            return "Duplicate ".concat(title, " with measurements");
        },
        _a[T.COLLECTION_EDIT_COPY_SUBFORM_SUCCESS] = function (_a) {
            var title = _a.title;
            return "Copied ".concat(title);
        },
        _a[T.COLLECTION_EDIT_SAVE_ERROR] = 'Failed to save collection',
        _a[T.COLLECTION_IMPORT_CHOOSE_FORM] = 'Choose a form to import into',
        _a[T.COLLECTION_IMPORT_FORM] = 'Form',
        _a[T.COLLECTION_IMPORT_CHOOSE_JOB] = 'Choose a job to import into',
        _a[T.COLLECTION_IMPORT_JOB] = 'Job',
        _a[T.COLLECTION_IMPORT_MAP_FIELDS] = 'Map your CSV fields into your form',
        _a[T.COLLECTION_IMPORT_CHOOSE_FILE_TYPE] = function (fileType) { return "Choose a ".concat(fileType, " file to import from"); },
        _a[T.COLLECTION_IMPORT_EXCEL_TEMPLATE] = 'Download the template for importing with your chosen form',
        _a[T.COLLECTION_IMPORT_EXCEL_USER_GUIDE] = 'Learn more in our user guide on how to import your data',
        _a[T.COLLECTION_IMPORT_EXCEL_USER_GUIDE_LINK] = 'https://support.ikegps.com/hc/en-us/articles/28311181980557-IKE-Office-Pro-Bulk-Import-User-Guide',
        _a[T.COLLECTION_IMPORT_FILE_CSV] = 'CSV File',
        _a[T.COLLECTION_IMPORT_FILE_EXCEL] = 'Excel File',
        _a[T.COLLECTION_IMPORT_TOO_MANY] = function (_a) {
            var count = _a.count, max = _a.max;
            return "Cannot import more than ".concat(max, " collections.");
        },
        _a[T.COLLECTION_IMPORT_FAILED] = 'Failed to import collections.',
        _a[T.COLLECTION_IMPORT_GO] = 'Import',
        _a[T.COLLECTION_IMPORT_CHOOSE_CSV_MAPPING] = 'Select CSV field',
        _a[T.COLLECTION_IMPORT_TITLE] = 'Import Collections',
        _a[T.COLLECTION_IMPORT_SUCCESS] = function (_a) {
            var count = _a.count;
            return "".concat(count, " ").concat(count === 1 ? 'collection' : 'collections', " imported!");
        },
        _a[T.COLLECTION_IMPORT_FIELD_INVALID] = function (_a) {
            var field = _a.field;
            return "Field cannot be imported into ".concat(field);
        },
        _a[T.COLLECTION_IMPORT_NOT_ALLOWED] = 'You do not have the correct permissions to import collections.',
        _a[T.DISCARD_CHANGES_TITLE] = 'Discard changes',
        _a[T.DISCARD_CHANGES_CONFIRM] = 'Are you sure you want to discard unsaved changes?',
        _a[T.DISCARD_CHANGES_DISCARD] = 'Discard',
        _a[T.DISTANCE_MISSING] = 'Missing distance',
        _a[T.DISTANCE_HORIZONTAL] = 'Horizontal distance',
        _a[T.DISTANCE_VERTICAL] = 'Vertical distance',
        _a[T.DISTANCE_VECTOR] = 'Vector',
        _a[T.DISTANCE_SAG] = 'Sag',
        _a[T.DEPARTMENT_SELECTOR_TITLE] = 'Change Department',
        _a[T.DEPARTMENT_SELECTOR_ACCEPT] = 'Change',
        _a[T.DEPARTMENT_SELECTOR_SUCCESS] = 'Department changed',
        _a[T.DEPARTMENT_SELECTOR_CURRENT] = 'Current',
        _a[T.DEPARTMENT_SELECTOR_DISABLED] = 'Disabled',
        _a[T.DEPARTMENTS_DISABLED] = 'Departments are disabled.',
        _a[T.DISMISS] = 'Dismiss',
        _a[T.INPUT_REQUIRED] = 'Value required',
        _a[T.LAST_UPDATED_AT] = function (_a) {
            var timeString = _a.timeString;
            return "Last modified at ".concat(timeString);
        },
        _a[T.SEARCH] = 'Search jobs and collections',
        _a[T.SEARCH_RES] = 'Search Results',
        _a[T.CLEAR_SEARCH] = 'Clear search',
        _a[T.SEARCH_ERROR] = 'Search query is too long',
        _a[T.TAG_TITLE] = 'Jobs',
        _a[T.TAG_NAME] = 'Job Name',
        _a[T.TAG_FILTER] = 'Filter Jobs',
        _a[T.TAG_FILTER__SEARCH_EMPTY] = 'No results found',
        _a[T.TAG_ZOOM] = 'Zoom to jobs',
        _a[T.TAG_EXISTS] = function (name) { return "'".concat(name, "' already exists."); },
        _a[T.TAG_MERGE_TITLE] = 'Rename job',
        _a[T.TAG_MERGE_CONFIRM] = function (_a) {
            var collectionCount = _a.collectionCount, oldName = _a.oldName, newName = _a.newName;
            return "Are you sure you want to merge ".concat(collectionCount, " ").concat(collectionCount > 1 ? 'collections' : 'collection', " from '").concat(oldName, "' into '").concat(newName, "'?");
        },
        _a[T.TAG_TITLE_SELECTION] = function (count) {
            return "".concat(count, " collection").concat(count !== 1 ? 's' : '', " selected");
        },
        _a[T.TAG_PHOTO] = function (plural) { return "Tag Photo".concat(plural ? 's' : ''); },
        _a[T.BETA] = 'beta',
        _a[T.LEGACY] = 'legacy',
        _a[T.EXPORT_MENU_TITLE] = 'Export selected collections',
        _a[T.EXPORT_MENU_TITLE_DIRTY] = 'Please save your changes before exporting.',
        _a[T.EXPORT_MENU_TITLE_PERMISSION] = 'You don\'t have the appropriate permissions.',
        _a[T.EXPORT_MENU_TITLE_LIMIT] = function (_a) {
            var limit = _a.limit;
            return "Too many collections selected (max ".concat(limit, ")");
        },
        _a[T.EXPORTING_PDF_TITLE] = 'Generating PDF export',
        _a[T.EXPORTING_PDF_CONTENT] = 'PDF export generation in progress...',
        _a[T.EXPORT_KML] = 'KML',
        _a[T.EXCEL] = 'EXCEL',
        _a[T.EXCEL_BETA] = 'EXCEL (Beta)',
        _a[T.IMPORTABLE_EXCEL] = 'IMPORTABLE EXCEL',
        _a[T.CSV] = 'CSV',
        _a[T.EXPORT_JSON] = 'JSON',
        _a[T.EXPORT_REPORT] = 'IKE REPORT',
        _a[T.EXPORT_REPORT_SHORT] = 'IKE REPORT SHORT',
        _a[T.EXPORT_REPORT_COMPOSITE_PHOTO] = 'COMPOSITE PHOTO REPORT',
        _a[T.EXPORT_REPORT_COMPOSITE_PHOTO_ONLY] = 'ONLY COMPOSITE PHOTO REPORT',
        _a[T.EXPORT_REPORT_PHOTO] = 'PHOTO REPORT',
        _a[T.EXPORT_SPIDA_CALC] = 'SPIDACALC WITH PHOTOS',
        _a[T.EXPORT_SPIDA_CALC_NO_PHOTO] = 'SPIDACALC NO PHOTOS',
        _a[T.EXPORT_O_CALC] = 'OCALC',
        _a[T.EXPORT_POLEFOREMAN] = 'POLEFOREMAN',
        _a[T.EXPORT_IKE_POLEFOREMAN] = 'IKE POLEFOREMAN',
        _a[T.EXPORT_IMAGE_ZIP] = 'IMAGE ZIP',
        _a[T.EXPORT_DDS] = 'DISTRIBUTION DESIGN STUDIO (DDS) (BETA)',
        _a[T.EXPORT_NOT_EVERYTHING_EXPORTED] = 'Not all collections could be exported because no locations were provided',
        _a[T.EXPORT_DEPRECATED] = 'This export is going to be removed. If you experience problems, please contact support.',
        _a[T.FIELD_VECTOR_P2P_DISPLAY] = function (_a) {
            var length = _a.length, angle = _a.angle;
            return "".concat(length, " at ").concat(angle);
        },
        _a[T.FORM_TITLE] = 'Forms',
        _a[T.FORM_NAME] = 'Name',
        _a[T.FORM_DESCRIPTION] = 'Description',
        _a[T.FORM_VERSION] = 'Current version',
        _a[T.FORM_UPDATED_AT] = 'Last Modified',
        _a[T.FORM_EDIT] = 'Edit Form',
        _a[T.FORM_EDIT_TITLE] = 'Form Information',
        _a[T.FORM_CREATE] = 'Create Form',
        _a[T.FORM_IMPORT] = 'Import Form',
        _a[T.FORM_IMPORT_POLEFOREMAN] = 'Create IKE PoleForeman Form',
        _a[T.FORM_IMPORT_POLEFOREMAN_ERROR_DATABASE] = 'Error fetching IPF databases. Please try again later.',
        _a[T.FORM_IMPORT_POLEFOREMAN_OK] = 'Submit',
        _a[T.FORM_IMPORT_POLEFOREMAN_FETCHING_ORGS] = 'Fetching organizations...',
        _a[T.FORM_IMPORT_POLEFOREMAN_SELECT_ORG] = 'Select an organization',
        _a[T.FORM_IMPORT_POLEFOREMAN_FETCHING_OP_CO] = 'Fetching operating companies.\nThis may take a few moments...',
        _a[T.FORM_IMPORT_POLEFOREMAN_ERROR_OP_CO] = 'Error loading operating companies. Please try again later.',
        _a[T.FORM_IMPORT_POLEFOREMAN_SINGLE_OP_CO] = function (opCo) { return "Single operating company (".concat(opCo, ") found. Creating form..."); },
        _a[T.FORM_IMPORT_POLEFOREMAN_SELECT_OP_CO] = 'Select an operating company',
        _a[T.FORM_IMPORT_POLEFOREMAN_DESCRIPTION] = 'Pick an Organization\'s IKE PoleForeman database',
        _a[T.FORM_IMPORT_POLEFOREMAN_OP_CO_DESCRIPTION] = 'Pick from one of the available Operating Companies within the selected organization\'s database',
        _a[T.FORM_IMPORT_POLEFOREMAN_NO_DATABASES] = 'You do not have access to any IKE PoleForeman databases. Please check with your IKE Access administrator or ikeGPS staff to configure access.',
        _a[T.FORM_IMPORT_POLEFOREMAN_NO_OPERATING_COMPANIES] = 'The selected database seems to be malformed and does not contain any operating companies. Please check with your IPF database administrator',
        _a[T.FORM_IMPORT_POLEFOREMAN_ERROR_CREATION] = 'Error creating IKE PoleForeman form. Please try again later.',
        _a[T.FORM_IMPORT_UPLOAD_BUTTON] = 'Click to upload',
        _a[T.FORM_IMPORT_CONFIRM] = 'Submit',
        _a[T.FORM_IMPORT_SUCCEED] = 'Form imported successfully!',
        _a[T.FORM_IMPORT_CHOOSE_FILE] = 'Choose a supported form file to import from',
        _a[T.FORM_NEW_POLEFOREMAN_FORM] = 'New IKE PoleForeman Form',
        _a[T.FORM_PLA_SUPPORT] = 'PLA Support',
        _a[T.FORM_LIST_ADD] = 'Add item',
        _a[T.FORM_FIELD_DISPLAY_NAME] = 'Display name',
        _a[T.FORM_FIELD_ANNOTATION_LABEL_FIELD_ID] = 'Annotation Label Field Id',
        _a[T.FORM_FIELD_DESCRIPTION] = 'Description',
        _a[T.FORM_FIELD_TYPE] = 'Field type',
        _a[T.FORM_FIELD_ADD_HIDE] = 'Hide create field',
        _a[T.FORM_FIELD_MOVE_UP] = 'Move field up',
        _a[T.FORM_FIELD_MOVE_DOWN] = 'Move field down',
        _a[T.FORM_OPTION_CLONEABLE] = 'Cloneable',
        _a[T.FORM_OPTION_CLONEABLE_TITLE] = 'Clone to new collection in IKE Field',
        _a[T.FORM_OPTION_LABEL] = 'Label',
        _a[T.FORM_OPTION_LABEL_TITLE] = function (_a) {
            var isRoot = _a.isRoot;
            return "Label for each ".concat(isRoot ? 'form' : 'subform');
        },
        _a[T.FORM_OPTION_SECONDARY_LABEL] = 'Secondary label',
        _a[T.FORM_OPTION_HIDE] = 'Hide',
        _a[T.FORM_OPTION_HIDE_TITLE] = 'Hide on IKE Field',
        _a[T.FORM_OPTION_ADMIN_ONLY] = 'Admin-only',
        _a[T.FORM_OPTION_ADMIN_ONLY_TITLE] = 'Make editable by admin users only',
        _a[T.FORM_OPTION_STATUS] = 'Status',
        _a[T.FORM_OPTION_STATUS_TITLE] = 'Use this field as the status',
        _a[T.FORM_OPTION_MAP_COLOR] = 'Map Color',
        _a[T.FORM_OPTION_MAP_COLOR_TITLE] = 'Use this field to set collection map colors',
        _a[T.FORM_OPTION_REQUIRED] = 'Required',
        _a[T.FORM_OPTION_REQUIRED_TITLE] = 'This field is required',
        _a[T.FORM_OPTION_ADDRESS] = 'Address',
        _a[T.FORM_OPTION_ADDRESS_TITLE] = 'Make this field an address lookup',
        _a[T.FORM_OPTION_LOCKED] = 'Locked for PLA support',
        _a[T.FORM_FIELD_CHOOSE] = 'Select a field to add',
        _a[T.FORM_FIELD_ADD] = function (_a) {
            var name = _a.name;
            return "Add field to ".concat(name || 'form');
        },
        _a[T.FORM_FIELD_CANNOT_CHANGE] = 'Populated fields cannot be changed',
        _a[T.FORM_FIELD_DELETE] = 'Delete field',
        _a[T.FORM_FIELD_DELETE_TITLE] = 'Delete field',
        _a[T.FORM_FIELD_DELETE_CONFIRM] = function (_a) {
            var name = _a.name;
            return "Are you sure you want to delete field ".concat(name, "?");
        },
        _a[T.FORM_FIELD_NESTED_LIST_DELETE] = 'Delete value',
        _a[T.FORM_FIELD_NESTED_LIST_DELETE_TITLE] = 'Delete value',
        _a[T.FORM_FIELD_NESTED_LIST_DELETE_CONFIRM] = 'Are you sure you want to delete this value and all children?',
        _a[T.FORM_DELETE] = 'Delete',
        _a[T.FORM_DELETE_TITLE] = 'Delete Form',
        _a[T.FORM_DELETE_CONFIRM] = function (_a) {
            var name = _a.name;
            return "Are you sure you would like to delete form: ".concat(name, "?'");
        },
        _a[T.FORM_DELETE_SUCCESS] = function (_a) {
            var name = _a.name;
            return "Deleted ".concat(name);
        },
        _a[T.FORM_SHARE] = 'Share To Department',
        _a[T.FORM_SHARE_TITLE] = 'Share Form',
        _a[T.FORM_SHARE_CONFIRM] = function (_a) {
            var name = _a.name;
            return "Share ".concat(name, ":");
        },
        _a[T.FORM_SHARE_SUCCESS] = function (_a) {
            var name = _a.name;
            return "Shared ".concat(name);
        },
        _a[T.FORM_REFRESH] = 'Refresh Form',
        _a[T.FORM_REFRESH_MODAL_TITLE] = 'Form Refresh',
        _a[T.FORM_REFRESH_MODAL_TITLE_ERROR] = 'Form Refresh Error',
        _a[T.FORM_REFRESH_MODAL_ERROR] = function (_a) {
            var name = _a.name;
            return "An error occurred while refreshing ".concat(name, ":");
        },
        _a[T.FORM_REFRESH_SUCCESS] = function (_a) {
            var name = _a.name;
            return "Successfully Refreshed ".concat(name);
        },
        _a[T.FORM_NAME_MISSING] = 'Name missing',
        _a[T.FORM_DESCRIPTION_MISSING] = 'Description missing',
        _a[T.FORM_ERROR_SAVING] = 'Error saving form',
        _a[T.FORM_ERROR_DELETING] = 'Error deleting form',
        _a[T.FIELD_DISPLAY_NAME_MISSING] = 'Display Name is required',
        _a[T.FIELD_TEXT] = 'Text',
        _a[T.FIELD_HEIGHT] = 'Height',
        _a[T.FIELD_NUMBER] = 'Number',
        _a[T.FIELD_TRUE_SIZE] = 'Photo Measure',
        _a[T.FIELD_DATE] = 'Date',
        _a[T.FIELD_SELECT_LIST] = 'Select List',
        _a[T.FIELD_YES_NO] = 'Yes No',
        _a[T.FIELD_NESTED_LIST] = 'Nested List',
        _a[T.FIELD_NESTED_LIST_TITLE] = function (_a) {
            var level = _a.level;
            return "Level ".concat(level, " Title");
        },
        _a[T.FIELD_NESTED_LIST_VALUE] = 'Value',
        _a[T.FIELD_FORM] = 'Subform',
        _a[T.FIELD_LOCATION] = 'Location',
        _a[T.FIELD_LOCATION_ACCURACY] = 'Accuracy',
        _a[T.FIELD_LOCATION_ALT] = 'Altitude',
        _a[T.FIELD_LOCATION_ALT_IKE] = 'IKE Altitude',
        _a[T.FIELD_LOCATION_ALT_GROUND] = 'Ground Altitude',
        _a[T.FIELD_LOCATION_ANTENNA_HEIGHT] = 'Antenna Height',
        _a[T.FIELD_LOCATION_FIX] = 'GPS Fix',
        _a[T.FIELD_LOCATION_FIX_DGPS] = 'DGPS',
        _a[T.FIELD_LOCATION_FIX_GPS] = 'GPS',
        _a[T.FIELD_LOCATION_FIX_PPS] = 'PPS',
        _a[T.FIELD_LOCATION_FIX_RTKFIXED] = 'RTK Fix',
        _a[T.FIELD_LOCATION_FIX_RTKFLOAT] = 'RTK Float',
        _a[T.FIELD_LOCATION_MANUAL] = 'Manually imported location',
        _a[T.FIELD_LOCATION_EDITED] = 'Manually edited location',
        _a[T.FIELD_LOCATION_TRUESIZE] = 'Target location',
        _a[T.FIELD_LOCATION_GPS] = 'GPS location',
        _a[T.FIELD_PROVIDER] = 'Provider',
        _a[T.FIELD_IMAGE] = 'Image',
        _a[T.FIELD_VECTOR] = 'Vector',
        _a[T.FIELD_ANCHOR] = 'Anchor (Beta)',
        _a[T.FIELD_VECTOR_PROVIDER_MANUAL] = 'Manual',
        _a[T.FIELD_VERTICAL_SEPARATION] = 'Vertical separation',
        _a[T.FIELD_FILE_TOOL] = 'File tool',
        _a[T.FIELD_FILE_TOOL_FILE_SIZE] = 'File size',
        _a[T.FORM_NOT_FOUND] = 'Form not found.',
        _a[T.LIST_MAP] = 'Map',
        _a[T.LIST_JOB_LIST] = 'Jobs',
        _a[T.LIST_FORM_LIST] = 'Forms',
        _a[T.LIST_USER_ACCOUNTS] = 'Accounts',
        _a[T.LIST_COLLECTION_IMPORT] = 'Import',
        _a[T.LOGIN] = 'Login',
        _a[T.LOGOUT] = 'Logout',
        _a[T.LOGIN_WITH_AUTH0] = 'Login with IKE ID',
        _a[T.LOGIN_NO_AUTH0_ACCOUNT] = 'I don\'t have an IKE ID account',
        _a[T.UNABLE_TO_START_SSO_SERVICE] = 'Unable to start IKE ID Service',
        _a[T.LOGIN_OFFICE] = 'Login to IKE Office',
        _a[T.FILE_NOT_SUPPORTED] = 'File type not supported.',
        _a[T.FILE_TOO_LARGE] = 'File is too large.',
        _a[T.FILE_DELETE] = 'Delete',
        _a[T.FILE_DELETE_TITLE] = 'Delete Uploaded File',
        _a[T.FILE_DELETE_MESSAGE] = function (file) { return "Do you want to delete ".concat(file, "?"); },
        _a[T.FILE_INFECTED] = "File appears to be infected and won't be saved into IKE Office.",
        _a[T.ME] = 'me',
        _a[T.MISSING_404_CODE] = '404',
        _a[T.MISSING_404_TITLE] = 'Page not found',
        _a[T.MISSING_404_BEFORE_LINK] = 'Please go back to the ',
        _a[T.MISSING_404_LINK] = 'homepage',
        _a[T.MISSING_404_AFTER_LINK] = ' and start from there',
        _a[T.MISSING_403_CODE] = '403',
        _a[T.MISSING_403_TITLE] = 'Missing Permissions',
        _a[T.MISSING_403_BEFORE_LINK] = 'Please go back to the ',
        _a[T.MISSING_403_LINK] = 'map',
        _a[T.MISSING_403_AFTER_LINK] = ' and start from there',
        _a[T.MISSING_PAGE_NA] = 'is not yet available',
        _a[T.MULTI_ORG_MAP] = 'Multi-Org Map',
        _a[T.NAVIGATE_MAP] = 'Go to map',
        _a[T.NO_LOCATION] = 'no location',
        _a[T.NO_CAPTURES] = 'No images collected',
        _a[T.SELECT_CAPTURE] = 'Select a capture to view',
        _a[T.NOTIFICATION_IN] = function (fieldName) { return "in ".concat(fieldName); },
        _a[T.NOTIFICATION_ERROR_TITLE] = 'Export failed with errors',
        _a[T.NOTIFICATION_WARNING_TITLE] = 'Export completed with warnings',
        _a[T.NOTIFICATION_CODE_REQUIRED] = 'is missing',
        _a[T.NOTIFICATION_CODE_DEFAULT] = 'was defaulted',
        _a[T.NOTIFICATION_CODE_INVALID] = 'is invalid',
        _a[T.NOTIFICATION_CODE_UNKNOWN] = 'is invalid',
        _a[T.NOTIFICATION_REASON_AGL] = 'AGL is higher than pole height.',
        _a[T.NOTIFICATION_REASON_NO_LOCATION] = 'No location.',
        _a[T.NOTIFICATION_REASON_NO_GUY_WIRE] = 'Missing guy wire.',
        _a[T.NOTIFICATION_REASON_CLIENT_ITEM] = function (item) {
            return "Missing ".concat(item, " from catalogue.");
        },
        _a[T.NOTIFICATION_REASON_OTHER] = function (item) { return item; },
        _a[T.NOTIFICATION_REASON_ONLY] = function (item) { return item; },
        _a[T.NOTIFICATION_REASON_MISSING] = function (item) { return item; },
        _a[T.REASON_IPF_ANCHOR_ASSEMBLY_TYPE_NOT_FOUND] = function (_a) {
            var displayDescription = _a.displayDescription;
            return "Anchor Assembly Type \"".concat(displayDescription, "\" was not found in the IPF database.");
        },
        _a[T.REASON_IPF_ANCHOR_LEAD_LENGTH_MISSING] = 'Anchor Lead Length is missing. Defaulting to 0.',
        _a[T.REASON_IPF_ANCHOR_TOO_MANY_GUYS] = 'Anchor has too many guy wires. The maximum is 3',
        _a[T.REASON_IPF_CONDUCTOR_TYPE_NOT_FOUND] = function (_a) {
            var displayDescription = _a.displayDescription, rulingSpan = _a.rulingSpan;
            return "Conductor Type \"".concat(displayDescription, " -> ").concat(rulingSpan, "\" was not found in the IPF database");
        },
        _a[T.REASON_IPF_CYCLE_DETECTED] = 'Cycle Detected -- This pole creates a collection linked loop, which IKE PoleForeman does not support.',
        _a[T.REASON_IPF_ISOLATED_POLES_DETECTED] = 'Isolated Poles Detected -- All collections need to be collection linked in order to enable span connectivity',
        _a[T.REASON_IPF_EQUIPMENT_ATTACHMENT_HEIGHT_MISSING] = 'Equipment Attachment Height is missing. Defaulting to 0 meters.',
        _a[T.REASON_IPF_EQUIPMENT_ORIENTATION_MISSING] = 'Equipment Orientation is missing. Defaulting to 0 degrees.',
        _a[T.REASON_IPF_EQUIPMENT_TYPE_NOT_FOUND] = function (_a) {
            var equipmentType = _a.equipmentType, displayDescription = _a.displayDescription;
            return "Equipment Type \"".concat(equipmentType, " -> ").concat(displayDescription, "\" was not found in the IPF database.");
        },
        _a[T.REASON_IPF_FRAMING_TYPE_NOT_FOUND] = function (_a) {
            var displayDescription = _a.displayDescription;
            return "Framing Type \"".concat(displayDescription, "\" was not found in the IPF database.");
        },
        _a[T.REASON_IPF_GUY_ATTACHMENT_HEIGHT_MISSING] = 'Guy Attachment Height is missing. Defaulting to 0',
        _a[T.REASON_IPF_GUY_TYPE_NOT_FOUND] = function (_a) {
            var displayDescription = _a.displayDescription;
            return "Guy Size ".concat(displayDescription, " was not found in the IPF database.");
        },
        _a[T.REASON_IPF_GUY_INSULATOR_TYPE_NOT_FOUND] = 'Guy Insulator Type was not found in the IPF database.',
        _a[T.REASON_IPF_JOINT_USE_CABLE_TYPE_NOT_FOUND] = function (_a) {
            var displayDescription = _a.displayDescription, rulingSpan = _a.rulingSpan;
            return "Joint Use Cable Type \"".concat(displayDescription, " -> ").concat(rulingSpan, "\" was not found in the IPF database.");
        },
        _a[T.REASON_IPF_MULTIPLE_SPANS_LINKED] = function (_a) {
            var poleCollectionTitle = _a.poleCollectionTitle, targetCollectionTitle = _a.targetCollectionTitle;
            return "Multiple Spans are linked between '".concat(poleCollectionTitle !== null && poleCollectionTitle !== void 0 ? poleCollectionTitle : 'No title', "' and '").concat(targetCollectionTitle !== null && targetCollectionTitle !== void 0 ? targetCollectionTitle : 'No title', "' when there can only be one. One of the spans will be used for this export");
        },
        _a[T.REASON_IPF_COLLECTION_LINK_ONE_WAY] = function (_a) {
            var poleCollectionTitle = _a.poleCollectionTitle, targetCollectionTitle = _a.targetCollectionTitle;
            return "The pole \"".concat(poleCollectionTitle, "\" needs to be collection linked to \"").concat(targetCollectionTitle, "\" to enable span connectivity");
        },
        _a[T.REASON_IPF_MULTIPLE_SPANS_SAME_TYPE] = function (_a) {
            var poleCollectionTitle = _a.poleCollectionTitle;
            return "The pole \"".concat(poleCollectionTitle, "\" has multiple linked spans of the same type. Only one type is allowed");
        },
        _a[T.REASON_IPF_POWER_CIRCUIT_TYPE_NOT_FOUND] = function (_a) {
            var displayDescription = _a.displayDescription;
            return "Power Circuit Type ".concat(displayDescription, " was not found in the IPF database");
        },
        _a[T.REASON_IPF_SERVICE_CANNOT_BE_COLLECTION_LINKED] = 'Service can not be collection linked',
        _a[T.REASON_IPF_SERVICE_LENGTH_MISSING] = 'Service Length is missing',
        _a[T.REASON_IPF_SERVICE_ENDPOINT_MISSING] = 'Service Endpoint Height is missing, Defaulting to Height of Attachment.',
        _a[T.REASON_IPF_SERVICE_MULTIPLE_POWER_CIRCUITS] = 'Multiple power subforms found in a single Service subform which is not supported',
        _a[T.REASON_IPF_SERVICE_MULTIPLE_TELEPHONE_CABLES] = 'Multiple telephone cables found in a single Service subform which is not supported',
        _a[T.REASON_IPF_SERVICE_MULTIPLE_CATV_CABLES] = 'Multiple CATV cables found in a single Service subform which is not supported',
        _a[T.REASON_IPF_REQUIRED_FIELD] = 'This field is required by IKE PoleForeman',
        _a[T.REASON_IPF_POWER_CIRCUIT_NEEDS_GROUP] = 'At least one Conductor and Framing must be set for Primary, Neutral, Secondary, or Shield',
        _a[T.REASON_IPF_POWER_CIRCUIT_PRIMARY_PHASE_HEIGHT_MISSING] = 'At least one of the Primary Phase Heights (A, B, or C) must be set',
        _a[T.REASON_IPF_POWER_CIRCUIT_SECONDARY_PHASE_HEIGHT_MISSING] = 'At least one of the Secondary Phase Heights (A, B, or C) must be set',
        _a[T.REASON_IPF_COUNT_ON_SPAN_MISMATCH] = function (_a) {
            var selfCount = _a.selfCount, otherCount = _a.otherCount, type = _a.type;
            return "Number of (".concat(type, ") on this span (").concat(selfCount, ") must equal the number of (").concat(type, ") on the connected span (").concat(otherCount, ")");
        },
        _a[T.REASON_IPF_SPAN_SAME_TYPE_LINKED] = function (_a) {
            var linkedPole = _a.linkedPole, type = _a.type;
            return "Link to pole: ".concat(linkedPole, " uses spans of the same type: '").concat(formatIpfSpanType(type), "'. One span must be changed to '").concat(ipfSpanTypes.filter(function (x) { return x !== type; }).map(formatIpfSpanType).join('\' or \''), "'");
        },
        _a[T.REASON_IPF_LOCATION_FALLBACK_TO_PHOTO] = 'The pole does not have a Location set, the elevation from the first captured IKE Photo will be used instead. Elevation can greatly impact PLA in IKE PoleForeman, so please make corrections as needed.',
        _a[T.REASON_IPF_TARGET_COLLECTION_NOT_FOUND] = "Linked collection is not a part of the export. Creating a Stand-In pole instead",
        _a[T.REASON_DDS_REQUIRED_FIELD] = 'This field is required by DDS',
        _a[T.REASON_DDS_RECOMMENDED_FIELD] = 'This field is recommended by DDS',
        _a[T.REASON_DDS_LOCATION_FALLBACK_TO_PHOTO] = 'The pole does not have a Location set, the elevation from the first captured IKE Photo will be used instead.',
        _a[T.REASON_DDS_EQUIPMENT_TYPE_NOT_FOUND] = function (_a) {
            var equipmentType = _a.equipmentType, displayDescription = _a.displayDescription;
            return "Equipment Type \"".concat(equipmentType, " -> ").concat(displayDescription, "\" was not found in the DDS catalogue.");
        },
        _a[T.NUMBER_INVALID] = 'Number invalid',
        _a[T.NUMBER_IMPRECISE] = function (_a) {
            var minimumInputPrecision = _a.minimumInputPrecision;
            return "".concat(minimumInputPrecision, " decimals or higher precision required");
        },
        _a[T.ORG_SEARCH] = 'Organization Wide Search',
        _a[T.UNKNOWN] = 'Unknown',
        _a[T.PHOTOMEASURE_JOIN] = 'Measurement will be linked to opposing span',
        _a[T.PHOTOMEASURE_JOIN_START] = function (title) {
            return "Measurement will link to: ".concat(title);
        },
        _a[T.PHOTOMEASURE_LINK] = 'Cancel Measure',
        _a[T.PHOTOMEASURE_LINK_START] = 'Measure Height',
        _a[T.PHOTOMEASURE_DELETE_ALL_TITLE] = 'Delete all measurements',
        _a[T.PHOTOMEASURE_DELETE_ALL_TEXT] = 'Are you sure you want to delete all of the measurements from the image?',
        _a[T.PHOTOMEASURE_HIDE_IMAGE_TITLE] = 'Hide image',
        _a[T.PHOTOMEASURE_HIDE_IMAGE_TEXT] = 'Are you sure you want to hide the image?',
        _a[T.PHOTOMEASURE_UNHIDE_IMAGE_TITLE] = 'Unhide image',
        _a[T.PHOTOMEASURE_UNHIDE_IMAGE_TEXT] = 'Are you sure you want to unhide the image?',
        _a[T.VERTICAL_SEPARATION_TOP] = 'Top',
        _a[T.VERTICAL_SEPARATION_BOTTOM] = 'Bottom',
        _a[T.VERTICAL_SEPARATION_INVALID] = 'Select a bottom height for vertical separation measurement',
        _a[T.USERNAME_INVALID] = 'Invalid username',
        _a[T.USER_MENU_FORM] = 'Form List',
        _a[T.USER_MENU_ACCOUNTS] = 'Accounts',
        _a[T.USER_MENU_SETTINGS] = 'User Settings',
        _a[T.USER_MENU_CHANGE_PASSWORD] = 'Change Password',
        _a[T.USER_MENU_LOGOUT] = 'Logout',
        _a[T.PASSWORD_CHANGE_PASSWORD] = 'Change Password',
        _a[T.PASSWORD_CHANGE_PASSWORD_DETAIL] = 'Are you sure you would like to change your password? You will receive a reset email which will be valid for 24 hours.',
        _a[T.PASSWORD_FORGOT_TITLE] = 'Reset password',
        _a[T.PASSWORD_FORGOT_EMAIL] = 'Email',
        _a[T.PASSWORD_FORGOT_ACCEPT] = 'Send reset email',
        _a[T.PASSWORD_RESET_EMAIL_SENT] = 'You have been sent a password reset email and will now be logged out.',
        _a[T.PASSWORD_FORGOT_SUCCESS] = 'A reset password link has been sent to you via email.',
        _a[T.PLA_SPIDACALC] = 'SPIDAcalc',
        _a[T.PLA_OCALC] = 'O-Calc',
        _a[T.PLA_DDS] = 'DDS',
        _a[T.PLA_POLEFOREMAN] = 'Legacy PoleForeman',
        _a[T.PLA_IKE_POLEFOREMAN] = 'IKE PoleForeman',
        _a[T.SPAN_O_MATIC] = 'Span-o-matic',
        _a[T.PRINT] = 'Print',
        _a[T.REPORT_PRE_LOAD_TITLE] = 'Exportable Reports',
        _a[T.REPORT_PRE_LOAD_LOADING] = 'Loading Report...',
        _a[T.REPORT_PRE_LOAD_INVALID_LICENSE] = 'You do not have a valid license to perform this action',
        _a[T.REPORT_COLLECTION_PLACE] = function (_a) {
            var index = _a.index, of = _a.of;
            return "".concat(index, " of ").concat(of);
        },
        _a[T.REPORT_COLLECTION_VECTOR] = function (_a) {
            var distance = _a.distance, bearing = _a.bearing;
            return "".concat(distance, " at ").concat(bearing);
        },
        _a[T.REPORT_COLLECTION_ANCHOR] = function (_a) {
            var distance = _a.distance, bearing = _a.bearing;
            return "".concat(distance, " at ").concat(bearing);
        },
        _a[T.REPORT_COLLECTION_LAT_LNG] = function (_a) {
            var lat = _a.lat, lng = _a.lng;
            return "(lat: ".concat(lat, ", lng: ").concat(lng, ")");
        },
        _a[T.REPORT_COLLECTION_LAT_LNG_ALT] = function (_a) {
            var lat = _a.lat, lng = _a.lng, alt = _a.alt;
            return "(lat: ".concat(lat, ", lng: ").concat(lng, ", alt: ").concat(alt, ")");
        },
        _a[T.ROLE_USER] = 'User',
        _a[T.ROLE_ADMIN] = 'Admin',
        _a[T.ROLE_EDITOR] = 'Editor',
        _a[T.ROLE_DOWNLOADER] = 'Downloader',
        _a[T.ROLE_VIEWER] = 'Viewer',
        _a[T.ROLE_DATA_ADMIN] = 'Data Admin',
        _a[T.SAVE] = 'Save',
        _a[T.SELECT] = function (value) { return "Select ".concat(value); },
        _a[T.SELECT_OPTION] = 'Select an option',
        _a[T.SELECT_MEASUREMENT] = 'Select attachment point to zoom',
        _a[T.SETTINGS_DATE_FORMAT] = 'Date Format',
        _a[T.SETTINGS_TITLE] = 'Change settings',
        _a[T.SETTINGS_UNITS] = 'Measurement Units',
        _a[T.SETTINGS_DONE] = 'Done',
        _a[T.SETTINGS_SAVED] = 'Settings saved...',
        _a[T.SETTINGS_ERROR_SAVING] = 'Error saving settings.',
        _a[T.SIGNUP] = 'Signup',
        _a[T.SIGNUP_EMAIL] = 'Email',
        _a[T.SIGNUP_EMAIL_INVALID] = 'Email invalid',
        _a[T.SIGNUP_FIRST_NAME] = 'First name',
        _a[T.SIGNUP_FIRST_NAME_INVALID] = 'First name invalid',
        _a[T.SIGNUP_LAST_NAME] = 'Last name',
        _a[T.SIGNUP_LAST_NAME_INVALID] = 'Last name invalid',
        _a[T.SUBMIT] = 'Submit',
        _a[T.BACK_TO_LOGIN] = 'Back to login',
        _a[T.SSO_MIGRATE_EMAIL_SENT] = "Success! We've sent instructions on how to set a password for your new IKE ID to your inbox.",
        _a[T.SSO_MIGRATE_EMAIL_EXISTING] = "Success! You can now login with the button below.",
        _a[T.SSO_MIGRATE_FAILED] = "We couldn't find an IKE Office account for this email address, or this account has already been upgraded. Please contact customer support if you continue to experience issues trying to upgrade to an IKE ID.",
        _a[T.SSO_UPGRADE_ACCOUNT] = 'Upgrade your IKE Office account',
        _a[T.SELECT_LIST_TITLE] = 'Text',
        _a[T.SELECT_LIST_VALUE] = 'Value',
        _a[T.ANCHOR_ALIGNMENT_INLINE] = 'Inline',
        _a[T.ANCHOR_ALIGNMENT_BISECT] = 'Bisect',
        _a[T.ANCHOR_ALIGNMENT_OTHER] = 'Other',
        _a[T.ACCURATE_ANCHOR_RELATED_SPAN_TITLE] = function (label) {
            return "Related Span ".concat(label);
        },
        _a[T.SORT_ASCENDING] = 'Ascending',
        _a[T.SORT_DESCENDING] = 'Descending',
        _a[T.SORT_TITLE] = 'Sort collections',
        _a[T.SORT_FIELD_COLLECTED_AT] = 'Collected at',
        _a[T.SORT_FIELD_COLLECTED_BY] = 'Collected by',
        _a[T.SORT_FIELD_UPDATED_AT] = 'Last Modified',
        _a[T.SORT_FIELD_NAME] = 'Title',
        _a[T.SORT_FIELD_STATUS] = 'Status',
        _a[T.SORT_FIELD_ASSIGNED] = 'Assigned to',
        _a[T.SPAN] = 'Span',
        _a[T.SPAN_LINK_TITLE] = 'Copy from existing Span',
        _a[T.SPAN_LINK_SELECT_CONTENT] = 'Select an existing span',
        _a[T.SPAN_LINK_SUCCESS] = function (_a) {
            var toSpan = _a.toSpan, fromCollection = _a.fromCollection;
            return "Created ".concat(toSpan, " from ").concat(fromCollection);
        },
        _a[T.SPAN_LINK_NO_MATCH] = 'No existing spans found near by',
        _a[T.SUBFORM_REMOVE_TITLE] = function (_a) {
            var title = _a.title;
            return "Remove ".concat(title);
        },
        _a[T.SUBFORM_REMOVE_CONFIRM] = function (_a) {
            var title = _a.title;
            return "Are you sure you want to remove this ".concat(title, "?");
        },
        _a[T.SUBFORM_REMOVE_REMOVE] = 'Remove',
        _a[T.TOOL_BASE] = 'Please select the base',
        _a[T.TOOL_SELECT] = 'Select',
        _a[T.TOOL_HEIGHT] = 'Height Marker',
        _a[T.TOOL_WIDTH] = 'Width Marker',
        _a[T.TOOL_CABLE_MEASURE] = 'Cable Measure',
        _a[T.TOOL_CABLE_MEASURE_INCREASE] = 'Increase cable size',
        _a[T.TOOL_CABLE_MEASURE_DECREASE] = 'Decrease cable size',
        _a[T.TOOL_ZOOM_IN] = 'Zoom in',
        _a[T.TOOL_ZOOM_OUT] = 'Zoom out',
        _a[T.TOOL_ZOOM_RESET] = 'Reset zoom',
        _a[T.TOOL_CROP_SET] = 'Set print area',
        _a[T.TOOL_BRIGHTNESS_INCREASE] = 'Increase brightness',
        _a[T.TOOL_BRIGHTNESS_DECREASE] = 'Decrease brightness',
        _a[T.TOOL_BRIGHTNESS_RESET] = 'Reset brightness',
        _a[T.TOOL_LASER_TOGGLE] = 'Laser Target',
        _a[T.TOOL_INFO_TOGGLE] = 'Show Info',
        _a[T.TOOL_MEASUREMENTS_CLEAR] = 'Delete all',
        _a[T.TOOL_DATE_TOGGLE] = 'Capture date',
        _a[T.TOOL_BEARING_TOGGLE] = 'Capture bearing',
        _a[T.TOOL_INSIGHT_DETECTIONS_TOGGLE_MARKERS] = 'Show/hide IKE Insight generated annotations',
        _a[T.TOOL_INSIGHT_DETECTIONS_TOGGLE_MASKS] = 'Show/hide IKE Insight generated masks',
        _a[T.TOOL_INSIGHT_DETECTIONS_MARKERS_NONE] = 'No IKE Insight annotations available',
        _a[T.TOOL_INSIGHT_DETECTIONS_MASKS_NONE] = 'No IKE Insight masks available',
        _a[T.TOOL_ARRANGE_ANNOTATIONS] = 'Arrange annotations',
        _a[T.TOPO_TOOL_RELOCATE_POLE] = 'Adjust pole location',
        _a[T.TOPO_TOOL_SNAP] = 'Universal snapping',
        _a[T.TOPO_SAVE_JOB] = 'Save full job',
        _a[T.TOPO_SUCCESS_SAVE_JOB] = function (_a) {
            var amount = _a.amount;
            return "Saved ".concat(amount, " collections");
        },
        _a[T.TOPO_UNSAVED_COLLECTION] = 'unsaved',
        _a[T.TOPO_SHOW_HIDE_LABELS] = 'Show/hide labels ─ Ctrl + L',
        _a[T.TOPO_SHOW_CAROUSEL] = 'Show image carousel',
        _a[T.TOPO_SHOW_COLLECTION_DATA] = 'Show collection data',
        _a[T.MAPMODE_LEGEND_DROPSPAN] = 'Drop span',
        _a[T.MAPMODE_LEGEND_ANCHOR] = 'Anchor',
        _a[T.MAPMODE_LEGEND_SPAN] = 'Span',
        _a[T.MAPMODE_LEGEND_UNKNOWN] = 'Unknown',
        _a[T.MAPMODE_LEGEND_COLLECTION_LABEL] = 'Collection Label',
        _a[T.MAPMODE_LEGEND_SELECTED_COLLECTION] = 'Selected Collection',
        _a[T.MAPMODE_LEGEND_LOCATION_RTK_FIXED] = 'Location RTK Fixed',
        _a[T.MAPMODE_LEGEND_LOCATION_REVIEWED] = 'Location Reviewed',
        _a[T.MAPMODE_LEGEND_LOCATION_RTK_FLOAT] = 'Location RTK Float / Manual',
        _a[T.MAPMODE_LEGEND_LOCATION_LOW_ACCURACY] = 'Location Lower Accuracy',
        _a[T.UNIT_SHORT_FEET] = 'ft',
        _a[T.UNIT_SHORT_INCH] = 'in',
        _a[T.UNIT_SHORT_METER] = 'm',
        _a[T.UNIT_SHORT_DEGREE] = 'deg',
        _a[T.UNIT_FEET_INCH] = 'Feet/Inches',
        _a[T.UNIT_METER] = 'Meters',
        _a[T.USER_ASSIGN_REQUIRED] = 'Choose a user',
        _a[T.YES] = 'Yes',
        _a[T.NO] = 'No',
        _a[T.LAT] = 'Latitude',
        _a[T.LNG] = 'Longitude',
        _a[T.ERROR] = 'error',
        _a[T.CREATED] = 'created',
        _a[T.UPDATED] = 'updated',
        _a[T.SKIPPED] = 'skipped',
        _a[T.FILTER] = 'Search list entries',
        _a[T.MESSAGE_MOBILE_VALIDATION_TITLE] = 'IKE Office on Mobile',
        _a[T.MESSAGE_MOBILE_VALIDATION_CONTENT] = 'IKE Office is not optimized for mobile use.',
        _a[T.MESSAGE_BROWSER_VALIDATION_TITLE] = 'IKE Office Browser Compatibility',
        _a[T.MESSAGE_BROWSER_VALIDATION_CONTENT] = 'Your browser is not fully supported for use with IKE Office. For more information please see ',
        _a[T.MESSAGE_BROWSER_VALIDATION_URL] = 'https://ikegps.com/support/ike-office-supported-browsers/',
        _a[T.MESSAGE_BROWSER_VALIDATION_URL_TEXT] = 'Supported Browsers',
        _a[T.LICENSE_CHECK_FAILED_TEXT] = 'You do not have a license to perform this action. Licenses are managed in IKE Access, learn about license management ',
        _a[T.LICENSE_CHECK_FAILED_LINK] = 'here',
        _a[T.LICENSE_CHECK_FAILED_CONTACT_ADMIN_TEXT] = 'Need help contacting your license admin? Reach out to ',
        _a[T.LICENSE_CHECK_FAILED_CONTACT_ADMIN_EMAIL] = 'support@ikegps.com',
        _a[T.REASON_SPIDA_CALC_TITLE_INVALID] = function (_a) {
            var displayDescription = _a.displayDescription;
            return "Pole id is invalid due to ".concat(displayDescription);
        },
        _a[T.REASON_SPIDA_CALC_SPAN_LINKING_TARGET_POLE_NOT_FOUND] = 'The target pole is not found in the export',
        _a[T.REASON_SPIDA_CALC_SPAN_LINKING_SPAN_MISMATCH] = 'Only "Fore Span" and "Back Span" linking is valid. This span and its contents will need to be manually linked in SPIDAcalc',
        _a[T.REASON_SPIDA_CALC_SPAN_LINKING_WIRES_COUNT_MISMATCH] = 'The wire count does not match its linked span wire count. This span and its contents will need to be manually linked in SPIDAcalc',
        _a[T.REASON_SPIDA_CALC_SPAN_LINKING_WIRES_TOO_MANY] = 'There are too many wire subforms with this attachment height. The maximum number is 2',
        _a[T.REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUYS_COUNT_MISMATCH] = 'The span-guy count does not match its linked span span-guy count. This span and its contents will need to be manually linked in SPIDAcalc',
        _a[T.REASON_SPIDA_CALC_SPAN_LINKING_WIRE_USAGE_GROUP_MISMATCH] = 'The wire usage group does not match its linked wire usage group. The parent span and its contents will need to be manually linked in SPIDAcalc',
        _a[T.REASON_SPIDA_CALC_SPAN_LINKING_WIRE_SIZE_MISMATCH] = 'The wire size does not match its linked wire size. The parent span and its contents will need to be manually linked in SPIDAcalc',
        _a[T.REASON_SPIDA_CALC_SPAN_LINKING_WIRE_TENSION_GROUP_MISMATCH] = 'The wire tension group does not match its linked wire tension group. The parent span and its contents will need to be manually linked in SPIDAcalc',
        _a[T.REASON_SPIDA_CALC_SPAN_LINKING_WIRE_OWNER_MISMATCH] = 'The wire owner does not match its linked wire owner. The parent span and its contents will need to be manually linked in SPIDAcalc',
        _a[T.REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUY_USAGE_GROUP_MISMATCH] = 'The span-guy usage group does not match its linked span-guy usage group. The parent span and its contents will need to be manually linked in SPIDAcalc',
        _a[T.REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUY_SIZE_MISMATCH] = 'The span-guy size does not match its linked span-guy size. The parent span and its contents will need to be manually linked in SPIDAcalc',
        _a[T.REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUY_TENSION_GROUP_MISMATCH] = 'The span-guy tension group does not match its span-guy tension group. The parent span and its contents will need to be manually linked in SPIDAcalc',
        _a[T.REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUY_OWNER_MISMATCH] = 'The span-guy owner does not match its linked span-guy owner. The parent span and its contents will need to be manually linked in SPIDAcalc',
        _a[T.REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUY_ATTACHMENT_HEIGHT_EXCEED_AGL] = 'The span-guy attachment height exceeds the AGL',
        _a[T.REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUY_MID_SPAN_HEIGHT_EXCEED_AGL] = 'The span-guy mid span height exceeds the AGL',
        _a[T.REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUY_HEIGHT_EXCEED_AGL] = 'The span-guy height exceeds the AGL',
        _a[T.REASON_EXPORT_IMPORTABLE_EXCEL_MULTIPLE_FORM_VERSIONS] = 'Collections contain multiple form versions',
        _a[T.REASON_EXPORT_IMPORTABLE_EXCEL_TOO_MANY_COLLECTIONS] = 'Cannot import more than 1000 collections at once',
        _a[T.REASON_EXPORT_IMPORTABLE_EXCEL_CELL_FORMAT_MISMATCH_STRING] = 'Cell must contain text',
        _a[T.REASON_EXPORT_IMPORTABLE_EXCEL_CELL_FORMAT_MISMATCH_LATITUDE] = 'Cell must contain a positive or negative number',
        _a[T.REASON_EXPORT_IMPORTABLE_EXCEL_CELL_FORMAT_MISMATCH_LONGITUDE] = 'Cell must contain a positive or negative number',
        _a[T.REASON_EXPORT_IMPORTABLE_EXCEL_CELL_FORMAT_MISMATCH_NUMBER] = 'Cell must contain a number',
        _a[T.REASON_EXPORT_IMPORTABLE_EXCEL_CELL_FORMAT_MISMATCH_BOOLEAN] = 'Cell must contain TRUE or FALSE',
        _a[T.REASON_EXPORT_IMPORTABLE_EXCEL_CELL_FORMAT_MISMATCH_ANCHOR] = 'Cell must contain Bisect, Inline, or Other',
        _a[T.REASON_EXPORT_IMPORTABLE_EXCEL_CELL_FORMAT_MISMATCH_LENGTH] = 'Cell must contain a length',
        _a[T.REASON_EXPORT_IMPORTABLE_EXCEL_CELL_FORMAT_MISMATCH_LENGTH_IMPERIAL] = 'Cell must contain a valid length in feet and inches (e.g. 5\' 11")',
        _a[T.REASON_EXPORT_IMPORTABLE_EXCEL_FORM_ID_MISMATCH] = 'Sheet is for importing a different Form',
        _a[T.REASON_EXPORT_IMPORTABLE_EXCEL_FORM_REVISION_MISMATCH] = 'Sheet is for a different revision of the Form',
        _a[T.REASON_EXPORT_IMPORTABLE_EXCEL_INVALID_DATE_FORMAT] = 'Invalid date format, must be YYYY-MM-DD',
        _a[T.REASON_EXPORT_IMPORTABLE_EXCEL_OPTION_DOES_NOT_EXIST] = 'Option does not exist',
        _a[T.IMPORT_FILE_NO_ROWS] = 'The imported file had no Collection rows',
        _a[T.HELP_MENU] = 'Help & Resources',
        _a[T.SUBMIT_SUPPORT_REQUEST] = 'Submit Support Request',
        _a[T.SUPPORT_PORTAL] = 'Support Portal',
        _a[T.RELEASE_NOTES] = 'Release Notes',
        _a[T.REVISION_ID] = 'Revision ID',
        _a[T.MODIFIED_AT] = 'Modified At',
        _a[T.MODIFIED_BY] = 'Modified By',
        _a[T.MODIFICATIONS] = 'Modifications',
        _a)
};
var ipfSpanTypes = ['fore_span', 'back_span', 'other'];
function formatIpfSpanType(spanType) {
    switch (spanType) {
        case 'fore_span':
            return 'Fore Span';
        case 'back_span':
            return 'Back Span';
        case 'other':
            return 'Other';
        default:
            var exhaustiveCheck = spanType;
            return exhaustiveCheck;
    }
}
function load(lang, translations) {
    exports.TRANSLATIONS[lang] = translations;
}
function Translate(translateKey, attrs) {
    var currentTranslations = exports.TRANSLATIONS[exports.CURRENT_LANG];
    if (currentTranslations == null) {
        return translateKey;
    }
    var translation = currentTranslations[translateKey];
    if (translation == null) {
        return translateKey;
    }
    if (typeof translation === 'string') {
        return translation;
    }
    if (typeof translation === 'function') {
        return translation(attrs != null ? attrs : {});
    }
    throw new Error('Non string translations are not supported yet!');
}
//# sourceMappingURL=index.js.map